<template>
  <el-container id="region" v-loading.fullscreen.lock.body="loading" :element-loading-text="loadingText"
    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <!--        新增员工弹框-->
    <el-dialog title="" :visible.sync="dialogFormVisible2">
      <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
        <span style="color: #3998F7;font-size: 22px;padding-top: 8px">新增员工</span>
        <span>
          <el-button @click="submitForm" type="primary" size="small">保 存</el-button>
          <el-button type="danger" @click="reset" size="small">取 消</el-button>
        </span>
      </div>
      <el-form :model="addForm" :rules="rules" hide-required-asterisk ref="ruleForm" class="demo-ruleForm"
        style="margin-left:70px" id="employees1">
        <el-form-item label="部门名称" class="region_star" :label-width="formLabelWidth" prop="bname">
          <el-input v-model="addForm.bname" disabled></el-input>
        </el-form-item>
        <el-form-item label="工号" class="region_star" :label-width="formLabelWidth" prop="employee_code">
          <el-input v-model="addForm.employee_code" autocomplete="off" placeholder="输入工号"></el-input>
        </el-form-item>
        <el-form-item label="姓名" class="region_star" :label-width="formLabelWidth" prop="name">
          <el-input v-model="addForm.name" autocomplete="off" placeholder="输入姓名" @change="changeWecomIdByName1"></el-input>
        </el-form-item>
        <el-form-item label="企业微信ID " :label-width="formLabelWidth" prop="wecom_id">
          <el-input v-model="addForm.wecom_id" disabled></el-input>
        </el-form-item>
        <el-form-item label="性别" :label-width="formLabelWidth" prop="sex">
          <el-select v-model="addForm.sex" placeholder="请选择" style="width: 100%;" clearable>
            <el-option label="男" value="男"></el-option>
            <el-option label="女" value="女"></el-option>
          </el-select>
        </el-form-item>
        <!--                <el-form-item label="出生日期" :label-width="formLabelWidth">-->
        <!--                    <el-date-picker placeholder="选择日期"-->
        <!--                                    v-model="addForm.birthday"-->
        <!--                                    type="date"-->
        <!--                                    format="yyyy 年 M 月 d 日"-->
        <!--                                    value-format="yyyy-MM-dd"-->
        <!--                                    style="width: 100%;">-->

        <!--                    </el-date-picker>-->
        <!--                </el-form-item>-->
        <el-form-item label="电子邮箱" :label-width="formLabelWidth" prop="email">
          <el-input v-model="addForm.email" autocomplete="off" placeholder="输入电子邮箱"></el-input>
        </el-form-item>
        <el-form-item label="手机" class="region_star" :label-width="formLabelWidth" prop="phone">
          <el-input v-model="addForm.phone" autocomplete="off" placeholder="输入手机号" @change="changeUserVoovIdByPhone1"></el-input>
        </el-form-item>
        <el-form-item label="腾讯会议用户id " :label-width="formLabelWidth" prop="om_user_id">
          <el-input v-model="addForm.om_user_id" disabled></el-input>
        </el-form-item>
        <el-form-item label="职务" :label-width="formLabelWidth" prop="duty">
          <el-input v-model="addForm.duty" autocomplete="off" placeholder="输入职务"></el-input>
        </el-form-item>
        <!--                <el-form-item label="用户名" :label-width="formLabelWidth" prop="username">-->
        <!--                    <el-input v-model="addForm.username" autocomplete="off" placeholder="输入用户名"></el-input>-->
        <!--                </el-form-item>-->
        <!--                <el-form-item label="密码" :label-width="formLabelWidth" prop="password">-->
        <!--                    <el-input v-model="addForm.password" autocomplete="off" placeholder="输入密码" type="password"></el-input>-->
        <!--                </el-form-item>-->
        <el-form-item label="角色" :label-width="formLabelWidth">
          <el-select v-model="addForm.role" multiple placeholder="请选择" style="width: 100%">
            <el-option v-for="item in form.options2" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择供应商" :label-width="formLabelWidth">
          <el-select v-model="addForm.supplier_id" placeholder="请选择" style="width: 100%">
            <el-option v-for="item in supplierArr" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="管理人员" :label-width="formLabelWidth">
          <el-switch v-model="addForm.zhuGuan" active-color="#13ce66" active-value="MANAGER" inactive-value="STAFF">
          </el-switch>
        </el-form-item>
        <el-form-item label="供应商人员" :label-width="formLabelWidth">
          <el-switch v-model="addForm.supplier_user" active-color="#13ce66" active-value="T" inactive-value="F">
          </el-switch>
        </el-form-item>
        <el-form-item label="外包人员" :label-width="formLabelWidth">
          <el-switch v-model="addForm.outsourcing_user" active-color="#13ce66" active-value="T" inactive-value="F">
          </el-switch>
        </el-form-item>
        <el-form-item label="在职" :label-width="formLabelWidth">
          <el-switch v-model="addForm.status" active-color="#13ce66" active-value="ACTIVE" inactive-value="INACTIVE">
          </el-switch>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!--        弹框-->
    <el-dialog title="" :visible.sync="dialogFormVisible">
      <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
        <span style="color: #3998F7;font-size: 22px;padding-top: 7px">{{ dialogTitler }}</span>
        <span>
          <el-button @click="openSubmit" type="primary" size="small">保 存</el-button>
          <el-button type="danger" @click="resetForm" size="small">取 消</el-button>
        </span>
      </div>
      <el-form :model="form" :rules="rules2" ref="ruleForm2" class="demo-ruleForm" style="margin-left: 70px"
        hide-required-asterisk>
        <el-form-item label="名称" class="region_star" :label-width="formLabelWidth" v-if="bianB == true" prop="eBname">
          <el-input v-model="form.eBname" autocomplete="off" placeholder="输入部门名称"></el-input>
        </el-form-item>
        <el-form-item label="所属部门" class="region_star" :label-width="formLabelWidth" v-if="bianB == false" prop="bname">
          <el-select v-model="form.bname" placeholder="请选择" collapse-tags style="width: 100%;" clearable>
            <el-option :value="mineStatusValue" style="height: auto">
              <el-tree :data="data" node-key="id" ref="tree2" highlight-current :props="defaultProps"
                :expand-on-click-node="false" @node-click="handleNodeClick2"> </el-tree>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名" class="region_star" :label-width="formLabelWidth" v-if="bianB == false" prop="name">
          <el-input v-model="form.name" autocomplete="off" placeholder="输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="性别" :label-width="formLabelWidth" v-if="bianB == false">
          <el-select v-model="form.sex" placeholder="请选择" style="width: 100%;" clearable>
            <el-option label="男" value="男"></el-option>
            <el-option label="女" value="女"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出生日期" :label-width="formLabelWidth" v-if="bianB == false">
          <el-date-picker placeholder="选择日期" v-model="form.birthday" type="date" format="yyyy 年 M 月 d 日"
            value-format="yyyy-MM-dd" style="width: 100%;"> </el-date-picker>
        </el-form-item>
        <el-form-item label="手机" class="region_star" :label-width="formLabelWidth" v-if="bianB == false" prop="phone">
          <el-input v-model="form.phone" autocomplete="off" placeholder="输入手机号" disabled></el-input>
        </el-form-item>
        <el-form-item label="职务" :label-width="formLabelWidth" v-if="bianB == false">
          <el-input v-model="form.duty" autocomplete="off" placeholder="输入职务"></el-input>
        </el-form-item>
        <el-form-item label="角色" :label-width="formLabelWidth" v-if="bianB == false">
          <el-select v-model="form.role" multiple placeholder="请选择" style="width: 100%">
            <el-option v-for="item in form.options2" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="管理人员" :label-width="formLabelWidth" v-if="bianB == false">
          <el-switch v-model="form.zhuGuan" active-color="#13ce66"> </el-switch>
        </el-form-item>
        <el-form-item label="在职" :label-width="formLabelWidth" v-if="bianB == false">
          <el-switch v-model="form.status" active-color="#13ce66"> </el-switch>
        </el-form-item>
      </el-form>
    </el-dialog>
    <div style="height: 98%;width:360px;background: white;" id="el-aside">
      <div style="height: 100%;border-bottom: 1px solid #DCDFE6;display: flex;
            flex-direction: column;margin-top: 12px">
        <el-row style="font-size: 20px;height: 30px">{{ title }}</el-row>
        <el-row class="redact" style="margin-top: 14px;min-height: 70px">
          <el-col :span="6" style="border-left: none;cursor: pointer" @click.native="addOpen(true, '添加部门')"
            :class="{ upActive: !updataActive3 }">
            <div>
              <img src="../../assets/images/add.png" alt="" />
              <p style="margin-top:5px">添加部门</p>
            </div>
          </el-col>
          <el-col :span="6" @click.native="deleteOpen" style="cursor: pointer" :class="{ upActive: !updataActive }">
            <img src="../../assets/images/pull.png" alt="" />
            <p style="margin-top:5px">移除部门</p>
          </el-col>
          <el-col :span="6" @click.native="addOpen(true, '编辑部门')" style="cursor: pointer"
            :class="{ upActive: !updataActive2 }">
            <img src="../../assets/images/redact.png" alt="" />
            <p style="margin-top:5px">编辑部门</p>
          </el-col>
          <el-col :span="6" @click.native="showModalAction" style="border-right: none;cursor: pointer"
            :class="{ upActive: !updataActive2 }">
            <img src="../../assets/images/allAdd.png" alt="" />
            <p style="margin-top:5px">批量导入</p>
          </el-col>
        </el-row>
        <el-autocomplete id="inputSeach" v-model="input" placeholder="请输入名称进行快速搜索" :fetch-suggestions="search"
          :default-expand-all="false" :trigger-on-focus="false" @select="handleSelect">
          <span slot-scope="{ item }">
            <span style="font-size: 12px;color: #ffffff; padding: 2px;background:#82d8ac;border-radius: 3px;"
              v-if="item.type === '部门'">{{ item.type }}</span>
            <span style="font-size: 12px;color: #ffffff; padding: 2px;background:#fdc490;border-radius: 3px;"
              v-if="item.type === '人员'">{{ item.type }}</span>
            <em>{{ item.value }}</em>
            <p style="font-size: 12px; color:#4a90e2; line-height: 1px;margin-top: 5px" v-show="item.ou_name">{{
              item.ou_name }}</p>
          </span>
        </el-autocomplete>
        <el-scrollbar style="border-top: none;flex-grow: 1;
                        border-right: 1px solid #DCDFE6;
                        border-left: 1px solid #DCDFE6 ">
          <!--                    <el-input-->
          <!--                            id="inputSeach"-->
          <!--                            type="text"-->
          <!--                            placeholder="请输入人员姓名进行快速搜索"-->
          <!--                            v-model="filterText"-->
          <!--                            :change="showPeople()">-->
          <!--                    </el-input>-->

          <el-tree class="filter-tree" :data="data" node-key="ou_id" :highlight-current="true"
            :expand-on-click-node="false" :current-node-key="currentNodeKey"
            :default-expanded-keys="defaultExpandedKeys" :default-checked-keys="defaultExpandedKeys"
            @node-click="handleNodeClick" :filter-node-method="filterNode" ref="tree">
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span style="display: inline-block;width: 17px;height: 18px;margin: 0 20px 0 0">
                <img v-bind:src="icon[node.level < 4 ? node.level - 1 : 2]" alt=" " />
              </span>
              <span>{{ node.label }}</span>
            </span>
          </el-tree>
        </el-scrollbar>
      </div>
    </div>
    <div style="height: 2%"></div>
    <el-main style="height: 100%;padding: 0 0 0 30px">
      <el-row class="header" style="padding-bottom: 20px">
        <el-col :span="8" style="color: #409EFF;margin-top: 10px;font-size: 20px">
          {{ tableDataName }}
        </el-col>
        <el-col :span="3" style="float: right;">
          <el-button :style="{ float: 'right' }" size="small" :disabled="updataActive2 ? false : true"
            style="background:#FF9901;color: #ffffff;border: none" @click="bhsredit()">编辑
          </el-button>
        </el-col>
      </el-row>
      <el-row style="margin-top: 20px">
        <el-button type="success" icon="el-icon-plus" size="small"
          style="background-color: #4EC880;border-color: #4EC880" @click="dialogFormVisible2Click"
          :disabled="!updataActive2">
          新增员工
        </el-button>
      </el-row>
      <el-table :data="tableData" stripe style="width: 100%;margin-top: 10px" border @row-click="rowClick"
        :header-cell-style="{ color: 'black' }">
        <!--                :row-class-name="tableRowClassName"-->

        <el-table-column label="选择" width="60" fixed="left">
          <template slot-scope="scope">
            <img :src="radio_checked" v-if="radio == scope.row.rowIndex" />
            <img :src="radio_unchecked" v-else="radio !== scope.row.rowIndex" />
          </template>
        </el-table-column>
        <el-table-column prop="name" label="姓名" sortable min-width="80"></el-table-column>
        <el-table-column prop="employee_code" label="工号" sortable min-width="80"></el-table-column>
        <el-table-column prop="duty" label="职务" sortable min-width="100"></el-table-column>
        <el-table-column prop="phone" label="手机" sortable min-width="100"></el-table-column>
        <el-table-column prop="isZhuGuan" label="管理人员" sortable min-width="80"></el-table-column>
        <el-table-column prop="status" label="状态" sortable min-width="80">
          <template slot-scope="scope">
            <span>{{ getStatus(scope.row.status) }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label-class-name="region_table_cell" label="操作" width="300">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click.native="phoneDetails(scope.row)">变更手机 </el-button>
            <el-button type="primary" size="small" @click.native="roleDetails(scope.row)">变更部门 </el-button>
            <el-button style="background: #FF9901;color: #fff;border: 1px solid #FF9901;border-radius: 10%;"
              size="small" @click.native="employeesDetails(scope.row)">详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--            <el-pagination-->
      <!--                    style="display: flex;justify-content: center;margin-top:30px "-->
      <!--                    @size-change="handleSizeChange"-->
      <!--                    @current-change="handleCurrentChange"-->
      <!--                    :current-page="currentPage4"-->
      <!--                    :page-sizes="[5,10]"-->
      <!--                    :page-size="5"-->
      <!--                    :pager-count="5"-->
      <!--                    layout="total, sizes, prev, pager, next, jumper"-->
      <!--                    :total="100">-->
      <!--            </el-pagination>-->
      <pagination :page="page" @changePage="changePageClick"></pagination>

      <!--            虚线-->
      <!--            <el-row style="padding:0 20px;border-bottom: 2px dashed #DCDFE6;padding-top:30px "></el-row>-->
      <div class="message" v-if="show" style="margin-top:40px;">
        <el-tabs v-model="activeName">
          <el-tab-pane label="基本信息" name="first">
            <el-row>
              <el-col :span="12" style="margin-bottom: 20px;">
                <el-col :span="6" style="font-weight:bold;font-size: 14px ">所属部门</el-col>
                <el-col :span="6" style="color: #87909A;font-size: 14px">{{ tableDataRow.department }}</el-col>
              </el-col>
              <el-col :span="12" style="margin-bottom: 20px;">
                <el-col :span="6" style="font-weight:bold;font-size: 14px ">工号</el-col>
                <el-col :span="6" style="color: #87909A;font-size: 14px">{{ tableDataRow.employee_code }}</el-col>
              </el-col>
              <el-col :span="12" style="margin-bottom: 20px;">
                <el-col :span="6" style="font-weight:bold;font-size: 14px ">姓名</el-col>
                <el-col :span="6" style="color: #87909A;font-size: 14px">{{ tableDataRow.name }}</el-col>
              </el-col>
              <el-col :span="12" style="margin-bottom: 20px;">
                <el-col :span="6" style="font-weight:bold;font-size: 14px ">性别</el-col>
                <el-col :span="6" style="color: #87909A;font-size: 14px">{{ tableDataRow.sex }}</el-col>
              </el-col>
              <el-col :span="12" style="margin-bottom: 20px;">
                <el-col :span="6" style="font-weight:bold;font-size: 14px ">手机</el-col>
                <el-col :span="6" style="color: #87909A;font-size: 14px">{{ tableDataRow.phone }}</el-col>
              </el-col>
              <el-col :span="12" style="margin-bottom: 20px;">
                <el-col :span="6" style="font-weight:bold;font-size: 14px ">电子邮箱</el-col>
                <el-col :span="6" style="color: #87909A;font-size: 14px">{{ tableDataRow.email }}</el-col>
              </el-col>
              <el-col :span="12" style="margin-bottom: 20px;">
                <el-col :span="6" style="font-weight:bold;font-size: 14px ">入职日期</el-col>
                <el-col :span="6" style="color: #87909A;font-size: 14px">{{ tableDataRow.onboard_date | dateFormat }}
                </el-col>
              </el-col>
              <el-col :span="12" style="margin-bottom: 20px;">
                <el-col :span="6" style="font-weight:bold;font-size: 14px ">离职日期</el-col>
                <el-col :span="6" style="color: #87909A;font-size: 14px">{{ tableDataRow.leave_date | dateFormat }}
                </el-col>
              </el-col>
              <el-col :span="12" style="margin-bottom: 20px;">
                <el-col :span="6" style="font-weight:bold;font-size: 14px ">担任职务</el-col>
                <el-col :span="6" style="color: #87909A;font-size: 14px">{{ tableDataRow.duty }}</el-col>
              </el-col>
              <el-col :span="12" style="margin-bottom: 20px;">
                <el-col :span="6" style="font-weight:bold;font-size: 14px ">管理人员</el-col>
                <el-col :span="6">
                  <el-switch disabled v-model="tableDataRow.zhuGuan" active-value="MANAGER" inactive-value="STAFF"
                    active-color="#13ce66"> </el-switch>
                </el-col>
              </el-col>
              <el-col :span="12" style="margin-bottom: 20px;">
                <el-col :span="6" style="font-weight:bold;font-size: 14px ">用户名</el-col>
                <el-col :span="6" style="color: #87909A;font-size: 14px">{{ tableDataRow.username }}</el-col>
              </el-col>
              <el-col :span="12" style="margin-bottom: 20px;">
                <el-col :span="6" style="font-weight:bold;font-size: 14px ">密码</el-col>
                <el-col :span="6" style="color: #87909A;font-size: 14px">
                  <!-- <el-input style="height:14px;border:none;padding-left: 0" v-model="tableDataRow.password" type="password" readonly="readonly"></el-input> -->
                  <el-col :span="6" style="color: #87909A;font-size: 14px">{{ tableDataRow.password }}</el-col>
                </el-col>
              </el-col>
              <el-col :span="12" style="margin-bottom: 20px;">
                <el-col :span="6" style="font-weight:bold;font-size: 14px ">企业微信ID</el-col>
                <el-col :span="6" style="color: #87909A;font-size: 14px">{{ tableDataRow.wecom_id }}</el-col>
              </el-col>
              <el-col :span="12" style="margin-bottom: 20px;">
                <el-col :span="6" style="font-weight:bold;font-size: 14px ">腾讯会议ID</el-col>
                <el-col :span="6" style="color: #87909A;font-size: 14px">{{ tableDataRow.om_user_id }}</el-col>
              </el-col>
              <el-col :span="24" style="margin-bottom: 20px;">
                <el-col :span="3" style="font-weight:bold;font-size: 14px ">营销项目</el-col>
                <el-col :span="21">
                  <span v-for="(item, j) in tableDataRow.project_item_array"
                    style="margin-right: 10px; color: #fff;font-size: 14px;padding : 5px 5px;background: #FF9901;border-radius: 10%;">{{
                    item.project_name
                    }}</span>
                </el-col>
              </el-col>
              <el-col :span="24" style="margin-bottom: 20px;">
                <el-col :span="3" style="font-weight:bold;font-size: 14px ">系统角色</el-col>
                <el-col :span="21">
                  <span v-for="(item, j) in tableDataRow.role"
                    style="margin-right: 10px; color: #fff;font-size: 14px;padding : 5px 5px;background: #FF9901;border-radius: 10%;">{{
                    item.role_name
                    }}</span>
                </el-col>
              </el-col>
              <el-col :span="12" style="margin-bottom: 20px;">
                <el-col :span="6" style="font-weight:bold;font-size: 14px ">在职</el-col>
                <el-col :span="6">
                  <el-switch v-model="tableDataRow.status" active-value="ACTIVE" inactive-value="INACTIVE"
                    active-color="#13ce66"> </el-switch>
                </el-col>
              </el-col>
              <el-col :span="24" style="margin-bottom: 20px;">
                <el-col :span="3" style="font-weight:bold;font-size: 14px ">备注</el-col>
                <el-col :span="3" style="color: #87909A;font-size: 14px">{{ tableDataRow.comments }}</el-col>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="扩展信息" name="second">
            <el-row>
              <el-col :span="item.input_type == 'COMMENTS' || item.input_type == 'LIST' ? '24' : '12'"
                style="margin-bottom: 20px;" v-for="(item, j) in extendedInfo1">
                <el-col v-if="item.input_type == 'LIST' ? true : false"
                  :span="item.input_type == 'COMMENTS' || item.input_type == 'LIST' ? '2' : '4'"
                  style="font-weight:bold;font-size: 14px ">{{ item.field_name }}
                </el-col>
                <div v-if="item.input_type == 'LIST' ? true : false"
                  style="color: #87909A;font-size: 14px;display: inline-block" v-for="(a, b) in item.field_value">
                  <span v-for="(c, d) in item.listArray"><span v-if="a == c.key"
                      style="padding: 3px;background: #FF9901;color: #fff;border-radius: 10%;margin-right: 10px;">{{
                      c.value1 }}</span></span>
                </div>
                <el-col v-if="item.input_type == 'LIST' ? false : true"
                  :span="item.input_type == 'COMMENTS' ? '2' : '4'" style="font-weight:bold;font-size: 14px ">{{
                  item.field_name }}
                </el-col>
                <el-col v-if="item.input_type == 'LIST' ? false : true"
                  :span="item.input_type == 'COMMENTS' ? '6' : '9'" style="color: #87909A;font-size: 14px">{{
                  item.field_value }}
                </el-col>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-main>
    <!--编辑-->
    <el-dialog :visible.sync="dialogVisible2" width="900px" id="wee" :show-close="false"
      style="vertical-align: center;margin-top: -100px">

      <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
        <span style="color: #3998F7;font-size: 22px;padding-top: 8px">员工详情</span>
        <span>
          <el-button type="primary" size="small" @click="addEmployees">
            保存
          </el-button>
          <el-button type="danger" size="small" @click="clickExtension">
            关闭
          </el-button>
        </span>
      </div>
      <div style="margin-top: -20px;width: 110%">
        <!-- <el-row style="padding-bottom: 10px;">
          <el-col :span="12">
            <div style="color: #3998F7;padding-top: 8px;font-size: 20px">员工详情</div>
          </el-col>

          <el-col :span="12">
            <div align="right">
              <el-button type="primary" size="small" @click="addEmployees">
                保存
              </el-button>
              <el-button type="danger" size="small" @click="clickExtension">
                关闭
              </el-button>
            </div>
          </el-col>
        </el-row> -->
        <el-tabs v-model="activeName2">
          <el-tab-pane label="基本信息" name="first">
            <div class="subjectList" style="margin-top: 20px;">
              <el-form id="employees" ref="formlist" :model="formlist" label-width="140px" hide-required-asterisk>
                <el-row>
                  <el-col :span="12">
                    <el-form-item class="region_star" label="所属部门" prop="department"
                      :rules="[{ required: true, message: '所属部门不能为空' }]">
                      <el-select v-model="formlist.department" disabled placeholder="请选择" collapse-tags
                        style="width: 100%;" clearable>
                        <el-option :value="mineStatusValue" style="height: auto">
                          <el-tree :data="data" node-key="id" ref="tree2" highlight-current :props="defaultProps"
                            :expand-on-click-node="false" @node-click="handleNodeClick2">
                          </el-tree>
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item class="region_star" label="工号" prop="employee_code"
                      :rules="[{ required: true, message: '工号不能为空' }]">
                      <el-input v-model="formlist.employee_code"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="12">
                    <el-form-item class="region_star" label="姓名" prop="last_name"
                      :rules="[{ required: true, message: '姓名不能为空' }]">
                      <el-input v-model="formlist.last_name" @change="changeWecomIdByName2"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="性别">
                      <el-select v-model="formlist.sex" filterable placeholder="请选择性别" style="width: 100%" clearable>
                        <el-option label="男" value="男"></el-option>
                        <el-option label="女" value="女"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="12">
                    <el-form-item label="手机">
                      <el-input v-model="formlist.phone" disabled></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="电子邮箱">
                      <el-input v-model="formlist.email" type="email"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="入职日期">
                      <el-date-picker placeholder="入职日期" v-model="formlist.onboard_date" type="date"
                        format="yyyy 年 M 月 d 日" value-format="yyyy-MM-dd" style="width: 100%;"
                        @change="chooseTimeRange0">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="离职日期">
                      <el-date-picker placeholder="选择日期" v-model="formlist.leave_date" type="date"
                        format="yyyy 年 M 月 d 日" value-format="yyyy-MM-dd" style="width: 100%;"
                        @change="chooseTimeRange2">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="12">
                    <el-form-item label="担任职务">
                      <el-input v-model="formlist.duty"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="管理人员">
                      <el-switch v-model="formlist.zhuGuan" active-color="#13ce66" active-value="MANAGER"
                        inactive-value="STAFF"> </el-switch>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="供应商">
                      <el-select v-model="formlist.supplier_id" placeholder="请选择" style="width: 100%">
                        <el-option v-for="item in supplierArr" :key="item.value" :label="item.label"
                          :value="item.value"> </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="供应商人员">
                      <el-switch v-model="formlist.supplier_user" active-color="#13ce66" active-value="T"
                        inactive-value="F"> </el-switch>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="系统角色">
                      <el-select v-model="formlist.role" multiple placeholder="请选择" style="width: 100%">
                        <el-option v-for="item in formlist.options2" :key="item.value" :label="item.label"
                          :value="item.value"> </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="用户名" class="region_star" autoComplete="off" prop="username"
                      :rules="[{ required: true, message: '姓名不能为空' }]">
                      <el-input v-model="formlist.username"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="密码">
                      <el-input v-model="formlist.password" show-password auto-complete="new-password" type="password"
                        maxlength="30"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="企业微信ID">
                      <el-input v-model="formlist.wecom_id"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="腾讯会议ID">
                      <el-input v-model="formlist.om_user_id"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="营销项目">
                      <el-select v-model="formlist.project_array" multiple placeholder="请选择参与的营销项目" style="width: 100%">
                        <el-option v-for="item in project_array" :key="item.project_id" :label="item.project_name"
                          :value="item.project_id"> </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item label="备注">
                  <el-input type="textarea" :rows="3" v-model="formlist.comments" placeholder="请输入备注信息"></el-input>
                </el-form-item>
                <el-form-item label="在职">
                  <el-switch v-model="formlist.status" active-color="#13ce66" active-value="ACTIVE"
                    inactive-value="INACTIVE"> </el-switch>
                </el-form-item>
                <el-form-item label="外包人员">
                  <el-switch v-model="formlist.outsourcing_user" active-color="#13ce66" active-value="T"
                    inactive-value="F"> </el-switch>
                </el-form-item>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="签到参数">
                    <el-input v-model="formlist.checkin_random" type="number" placeholder="请输入签到随机值(0-1之间)"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </el-tab-pane>
          <el-tab-pane label="扩展信息" name="second" v-if="isfalse" id="info">
            <div class="subjectList" style="margin-top: 20px;">
              <el-form hide-required-asterisk :ref="'list' + j" label-width="140px" v-for="(item, j) in extendedInfo"
                :model="extendedInfo[j]" :key="item.field_id">
                <el-col :span="item.input_type == 'COMMENTS' ? 24 : 12" v-if="item.input_type == 'TEXT'">
                  <el-form-item :label="item.label" class="region_star" prop="field_value"
                    :rules="item.mandatory == 'T' ? [{ required: true, message: item.label + '不能为空' }] : []">
                    <el-input v-model="item.field_value" placeholder="请输入文本" :disabled="item.readonly == 'T'">
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="item.input_type == 'COMMENTS' ? 24 : 12" v-else-if="item.input_type == 'NUMBER'">
                  <el-form-item :label="item.label" class="region_star" prop="field_value"
                    :rules="item.mandatory == 'T' ? [{ required: true, message: item.label + '不能为空' }] : []">
                    <el-input v-model="item.field_value" placeholder="请输入数字" type="number"
                      :disabled="item.readonly == 'T'"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="item.input_type == 'COMMENTS' ? 24 : 12" v-else-if="item.input_type == 'DATE'">
                  <el-form-item :label="item.label" class="region_star" prop="field_value"
                    :rules="item.mandatory == 'T' ? [{ required: true, message: item.label + '不能为空' }] : []">
                    <el-date-picker v-model="item.field_value" type="date" placeholder="选择日期时间" style="width: 100%"
                      format="yyyy-MM-dd" value-format="yyyy-MM-dd" :disabled="item.readonly == 'T'">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="item.input_type == 'COMMENTS' ? 24 : 12" v-else-if="item.input_type == 'TRUE-FALSE'">
                  <el-form-item :label="item.label">
                    <el-switch v-model="item.field_value" active-color="#13ce66" active-value="T" inactive-value="F"
                      :disabled="item.readonly == 'T'"> </el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="item.input_type == 'COMMENTS' ? 24 : 12" v-else-if="item.input_type == 'LIST'">
                  <el-form-item :label="item.label" class="region_star" prop="field_value"
                    :rules="item.mandatory == 'T' ? [{ required: true, message: item.label + '不能为空' }] : []">
                    <el-select v-model="item.field_value" :multiple="item.multiple == 'T'" placeholder="请选择"
                      style="width: 100%" :disabled="item.readonly == 'T'" clearable>
                      <el-option v-for="item in item.listArray" :key="item.key" :label="item.value1" :value="item.key">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="item.input_type == 'COMMENTS' ? 24 : 12" v-else>
                  <el-form-item :label="item.label" class="region_star" prop="field_value"
                    :rules="item.mandatory == 'T' ? [{ required: true, message: item.label + '不能为空' }] : []">
                    <el-input :rows="3" v-model="item.field_value" placeholder="请输入备注信息" type="textarea"
                      :disabled="item.readonly == 'T'"></el-input>
                  </el-form-item>
                </el-col>
              </el-form>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
    <!--        人员导入-->
    <el-dialog :visible.sync="showModal" :show-close="false" width="50%" :before-close="closeModal">
      <div slot="title">
        <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
          <span style="color: #3998F7;font-size: 22px">人员导入</span>
          <span>
            <el-button type="danger" size="small" @click.stop="closeModal">关闭</el-button>
          </span>
        </div>
      </div>
      <el-form label-width="120px" class="a_modal">
        <el-form-item label="下载现有数据">
          <el-button type="primary" size="small" @click="exportUserList">
            下载
          </el-button>
          <i style="margin-left: 10px" class="el-icon-document"></i>
          <span>人员.xlsx</span>
        </el-form-item>
        <el-form-item label="下载模板文件">
          <a style="text-decoration: none;color: #ffff;" class=" el-button el-button--primary el-button--small"
            href="../../../static/人员数据导入模板.xlsx" download="人员数据导入模板.xlsx">下载</a>
          <i style="margin-left: 10px" class="el-icon-document"></i>
          <span>人员数据导入模板.xlsx</span>
        </el-form-item>
        <el-form-item label="上传文件" class="d_upload">
          <div style="display: flex;align-items: center">
            <!--            <el-input v-model="file" style="flex-grow: 1;margin-right: 15px"></el-input>-->
            <div
              style="border: 1px solid #ededed;height: 30px;flex-grow: 1;margin-right: 20px;display: flex;align-items: center;padding: 0 10px;">
              {{ file }}
            </div>
            <el-upload :data="updata" style="flex-shrink: 0;" class="upload-demo" ref="upload" accept=".xlsx,.xls"
              action="" :file-list="fileList" :on-change="handleChange" :limit="1" :auto-upload="false">
              <el-button slot="trigger" size="small" type="success">选择文件</el-button>
              <el-button style="margin-left: 10px;" size="small" type="warning" @click.stop="imortDataClick">
                导入数据
              </el-button>
            </el-upload>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog class="regionUser" :visible.sync="showModal2" :show-close="false" width="900px"
      style="margin-top: -20px">
      <div slot="title">
        <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
          <span style="color: #3998F7;font-size: 22px">错误提示</span>
          <span>
            <el-button type="primary" size="small" @click="handleExportData">下载错误信息</el-button>
            <el-button type="danger" size="small" @click="showModal2 = false">关闭</el-button>
          </span>
        </div>
      </div>

      <div style="font-size: 12px;color: red;margin-top: -25px">
        <p>
          <!-- 错误提示：部分数据导入失败 请修改后重新导入报错的数据 -->
          错误提示：部分数据有误 请修改后重新导入数据
        </p>
        <p>数据正常：{{ this.excelData.length - 1 - this.errData.length }}条</p>
        <p>数据异常：{{ this.errData.length }}条</p>
      </div>

      <el-table border :data="hcpArray" stripe height="450px" style="width: 100%;margin-top: 20px"
        header-cell-class-name="headerStyle" :default-sort="{ prop: 'date', order: 'descending' }">
        <el-table-column type="index" :index="1" label="序号" style="font-size: 20px;color: #585757" width="75">
        </el-table-column>
        <el-table-column prop="ou_name" label="所属部门" min-width="120px" sortable> </el-table-column>
        <el-table-column prop="parent_ou_name" label="上级部门" min-width="120px" sortable> </el-table-column>
        <el-table-column prop="code" label="工号" min-width="100%" sortable> </el-table-column>
        <el-table-column prop="user_name" label="姓名" min-width="100%" sortable> </el-table-column>
        <el-table-column prop="gender" label="性别" min-width="100%" sortable> </el-table-column>
        <el-table-column prop="birthday" label="出生日期" min-width="150%" sortable> </el-table-column>
        <el-table-column prop="phone" label="手机" min-width="120px" sortable> </el-table-column>
        <el-table-column prop="email" label="邮箱" min-width="120px" sortable> </el-table-column>
        <el-table-column prop="title" label="职务" min-width="100%" sortable> </el-table-column>
        <el-table-column prop="inductionDate" label="入职日期" min-width="100%" sortable> </el-table-column>
        <el-table-column prop="departureDate" label="离职日期" min-width="100%" sortable> </el-table-column>
        <el-table-column prop="role" label="角色" min-width="100%" sortable> </el-table-column>
        <el-table-column prop="isManager" label="是否管理人员" min-width="150" sortable> </el-table-column>
        <el-table-column prop="status" label="是否在职" min-width="150" sortable> </el-table-column>
        <el-table-column prop="crm_name" label="用户名" min-width="120" sortable> </el-table-column>
        <!--        <el-table-column-->
        <!--            prop="passWord"-->
        <!--            label="密码"-->
        <!--            min-width="120"-->
        <!--            sortable>-->
        <!--        </el-table-column>-->

        <el-table-column fixed="right" label="报错信息" width="240px">
          <template slot-scope="scope">
            <div>
              <span style="font-size: 10px;color: red" v-html="scope.row.message.replace(/！/g, '！\<br\/\>')"></span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!--编辑手机号-->
    <el-dialog :visible.sync="showModal3" :show-close="false" id="phone" width="900px" style="margin-top: -20px">
      <div slot="title">
        <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
          <span style="color: #3998F7;font-size: 22px">变更手机</span>
          <span>
            <el-button type="primary" size="small" @click="baocun2">保存</el-button>
            <el-button type="danger" size="small" @click="colse2">关闭</el-button>
          </span>
        </div>
      </div>
      <div style="border-bottom: 2px hidden #ccc"></div>
      <el-form :model="phoneObj" ref="phone" hide-required-asterisk>
        <el-form-item label="原手机号" :label-width="formLabelWidth">
          <p style="font-size: 14px;color: #4A90E2;margin:0;">{{ oldPhone }}</p>
        </el-form-item>
        <el-form-item label="新手机号" :label-width="formLabelWidth" prop="phone" class="region_star"
          :rules="[{ required: true, message: '手机号不能为空' }]">
          <el-input v-model="phoneObj.phone" placeholder="输入手机号"></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!--编辑部门-->
    <el-dialog :visible.sync="showModal4" :show-close="false" id="phone" width="900px" style="margin-top: -20px"
      @open="bhsropen">
      <div slot="title">
        <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
          <span style="color: #3998F7;font-size: 22px">变更部门</span>
          <span>
            <el-button type="primary" size="small" @click="updateOuUserList()">保存</el-button>
            <el-button type="danger" size="small" @click="colse4">关闭</el-button>
          </span>
        </div>
      </div>
      <div style="border-bottom: 2px hidden #ccc"></div>
      <el-form :model="bhsrObj" ref="bhsrObj" hide-required-asterisk>
        <!-- <el-form-item label="变更前" :label-width="formLabelWidth">
          <el-input v-model="bhsrObj.before" disabled></el-input>
        </el-form-item> -->
        <!-- <el-form-item class="region_star" label="变更后" prop="after" :label-width="formLabelWidth">
          <el-select v-model="bhsrObj.after" placeholder="请选择" collapse-tags style="width: 100%;" clearable>
            <el-option :value="mineStatusValue" style="height: auto">
              <el-tree :data="afterdata" node-key="id" ref="tree2" show-checkbox highlight-current :props="defaultProps" :expand-on-click-node="false" @node-click="handleClick2">
              </el-tree>
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="变更前" :label-width="formLabelWidth">
          <el-select disabled multiple placeholder="请选择" style="width: 100%" v-model="bhsrObj.bhsrbefore">
            <el-option v-for="item in afterdata" :key="item.ou_id" :label="item.ou_name" :value="item.ou_id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="变更后" :label-width="formLabelWidth">
          <el-select multiple placeholder="请选择" style="width: 100%" v-model="bhsrObj.bhsrafter">
            <el-option v-for="item in afterdata" :key="item.ou_id" :label="item.ou_name" :value="item.ou_id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="" :visible.sync="editdialogVisible">
      <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
        <span style="color: #3998F7;font-size: 22px;padding-top: 8px">部门详情</span>
        <span>
          <el-button @click="updateOuRoleUserList()" type="primary" size="small">保 存</el-button>
          <el-button type="danger" @click="editdialogVisible = false" size="small">取 消</el-button>
        </span>
      </div>
      <el-form class="demo-ruleForm" style="margin-left:70px" :model="bhsreditObj" ref="bhsreditObj">
        <el-form-item label="部门名称" :label-width="formLabelWidth">
          <el-input v-model="bhsreditObj.bhsrname"> </el-input>
        </el-form-item>
        <el-form-item label="部门主管" :label-width="formLabelWidth">
          <el-select multiple placeholder="请选择" style="width: 100%" v-model="bhsreditObj.vipname">
            <el-option v-for="item in bhsrArray" :key="item.user_id" :label="item.username" :value="item.user_id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-container>
</template>

<script>
  import http from "../../APIService/http";
  import pagination from "../../components/pagination";
  import radio_checked from "../../assets/images/radio_checked.png";
  import radio_unchecked from "../../assets/images/radio_unchecked.png";
  import { MessageBox, Message } from "element-ui";
  import moment from "moment";
  import xlsx from "xlsx";
  import { export_json_to_excel } from "../../vendor/Export2Excel";
  import axios from "axios";

  export default {
    name: "region",
    data() {
      var checkPhone = (rule, value, callback) => {
        if (!value) {
          return callback(new Error("电话号码不能为空"));
        } else {
          const reg = /^1[3|4|5|6|7|8][0-9]\d{8}$/;
          // console.log(reg.test(value));
          if (reg.test(value)) {
            callback();
          } else {
            return callback(new Error("请输入正确的手机号"));
          }
        }
      };
      return {
        bhsrArray: [],
        bhsreditObj: {
          bhsrname: "",
          vipname: [],
        },
        bhsrObj: {
          bhsrbefore: [],
          bhsrafter: [],
        },
        loading: false,
        loadingText: "拼命加载中",
        excelData: [],
        errData: "",
        record: [],
        bname: "",
        opera_user_id: "",
        bname_ou_id: "",
        editdialogVisible: false,
        extendedInfo1: [],
        supplierArr: [],
        formlist: {
          user_id: "",
          key_id: "",
          //员工名
          last_name: "",
          onboard_date: "",
          leave_date: "",
          employee_code: "",
          comments: "",

          //编辑部门名
          eBname: "",
          //所属部门
          department: "",
          options1: [],
          //性别
          sex: "",
          //生日
          birthday: "",
          //手机
          phone: "",
          //职务
          duty: "",
          //角色
          role: [],
          options2: [],
          //状态
          status: "",
          //主管
          zhuGuan: "",
          ou_id: "",
          username: "",
          email: "",
          password: "",
          supplier_id: "",
          supplier_user: "",
          outsourcing_user: "",
          //企业微信的UserID
          wecom_id: "",
          //线上会议系统的用户ID
          om_user_id: "",
          project_array: [],
          checkin_random:null
        },
        extendedInfo: [],
        isfalse: false,
        dialogVisible2: false,
        activeName2: "first",
        oldPhone: "",
        activeName: "first",
        phoneObj: {
          phone: "",
        },
        arr: [],
        queryString: "",
        showModal: false,
        showModal2: false,
        showModal3: false,
        showModal4: false,
        isUpload: false,
        filterText: "",
        fileList: [],
        file: "",
        hcpArray: [],
        treeKey: "",
        radio_checked: radio_checked,
        radio_unchecked: radio_unchecked,
        radio: 0,
        myZhuGuan: "",
        myStatus: "",
        formeBname: "",
        tData: {},
        page: {
          current: 1,
          size: 10,
          total: 0,
        },
        tabActive: false,
        tableDataName: "",
        mynode: null,
        input: "",
        updataActive: false,
        updataActive2: false,
        updataActive3: false,
        // pageSize:5,
        // pageIndex:1,
        mineStatusValue: "",
        title: "组织架构",
        data: [],
        afterdata: [],
        defaultProps: {
          children: "children",
          label: "label",
        },
        icon: [require("../../assets/images/icon-t.png"), require("../../assets/images/icon-f.png"), require("../../assets/images/icon-g.png")],
        dialogFormVisible: false,
        dialogFormVisible2: false,
        selectUser: {},
        form: {
          user_id: "",
          key_id: "",
          //员工名
          name: "",
          //编辑部门名
          eBname: "",
          //所属部门
          bname: "",
          options1: [],
          //性别
          sex: "",
          //生日
          birthday: "",
          //手机
          phone: "",
          //职务
          duty: "",
          //角色
          role: [],
          options2: [],
          //状态
          status: "",
          //主管
          zhuGuan: "",
          ou_id: "",
        },
        addForm: {
          user_id: "",
          //员工名
          name: "",
          wecom_id:"",
          employee_code: "",
          //所属部门
          bname: "",
          options1: [],
          //性别
          sex: "",
          //生日
          // birthday: "",
          //手机
          phone: "",
          //腾讯会议用户id
          om_user_id:"",
          //职务
          duty: "",
          //角色
          role: [],
          options2: [],
          //状态
          status: "ACTIVE",
          //主管
          zhuGuan: "",
          ou_id: "",
          username: "",
          password: "",
          email: "",
          supplier_id: "",
          supplier_user: "F",
          outsourcing_user: "F",
        },
        rules: {
          name: [{ required: true, message: "请输入员工姓名", trigger: "blur" }],
          employee_code: [{ required: true, message: "请输入员工工号", trigger: "blur" }],
          bname: [{ required: true, message: "请选择所属部门", trigger: "change" }],
          phone: [
            { required: true, message: "电话号码不能为空", trigger: "blur" },
            // {validator: checkPhone, trigger: 'blur'}
          ],
        },
        rules2: {
          eBname: [{ required: true, message: "请输入部门名称", trigger: "blur" }],
          name: [{ required: true, message: "请输入员工姓名", trigger: "blur" }],
          bname: [{ required: true, message: "请选择所属部门", trigger: "change" }],
          phone: [{ required: true, message: "电话号码不能为空", trigger: "change" }],
        },
        formLabelWidth: "100px",
        dialogTitler: "部门详情",
        tableData: [
          /*{
                          radio: null,
                          name: '张三',
                          sex: "男",
                          birthday: "1998年4月五日",
                          duty: '职务',
                          phone: '12345678901',
                          status: '在职',
                          role: "",
                          zhuGuan: "是",
                      }*/
        ],
        tableDataRow: {
          radio: null,
          name: null,
          sex: null,
          birthday: null,
          duty: null,
          phone: null,
          status: null,
          role: null,
          zhuGuan: false,
          project_array: [],
          project_item_array: []
        },
        // currentPage4: 1,
        bianB: true,
        show: false,
        addKey: "",
        baocun: "",
        ou_id: "",
        parent_ou: "",
        tenant_id: "",
        data2: [],
        defaultExpandedKeys: [],
        val1: "",
        onOffupdataActive: false,
        depart: [],
        ou_name: "",
        treeDataNode: {},
        parent_ou_id: "",
        updata: {
          tenant_id: this.$store.getters.getUser.tenant_id,
          product_id: "CRM",
        },
        searchObj: {},
        currentNodeKey: "",
        numSuccess: 0,
        numError: 0,
        errorText: "",
        project_array: [],
      };
    },
    components: {
      pagination,
    },
    // watch: {
    //     filterText() {
    //         this.$refs.tree.filter(this.val1);
    //     }
    // },
    watch: {
      input(val) {
        if (!val) {
          this.$refs.tree.filter(val);
        }
      },
    },
    methods: {
      async getProject() {
        try {
          let user = this.$store.getters.getUser
          let data = {
            tenant_id: user.tenant_id
          }
          await http.post('/crm/project/getProjectByTenantId', data).then(res => {
            if (res.success === true) {
              this.project_array = res.data;
            }
          })
        } catch (e) {

        }
      },
      async getOuListNotTree() {
        try {
          let user = this.$store.getters.getUser;
          let data = {
            tenant_id: user.tenant_id,
          };
          await http.post("/wapi/v1/getOuListNotTree", data).then((res) => {
            debugger;
            this.afterdata = res.data;
          });
        } catch (err) {
          Message.error("获取失败！");
        }
      },
      //获取选择数据
      async getUserManagerOuList() {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          ou_id: this.tData.ou_id,
        };
        debugger;
        await http.post("/wapi/v1/getUserManagerOuList", data).then((res) => {
          debugger;
          // this.bhsreditObj.vipname = res.data.user_id;
          for (let i = 0; i < res.data.length; i++) {
            let user_id = res.data[i].user_id;
            debugger;
            this.bhsreditObj.vipname.push(user_id);
          }
        });
      },
      // 初入查询
      async getUserListByOu() {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          ou_id: this.tData.ou_id,
        };
        debugger;
        await http.post("/wapi/v1/getUserListByOu", data).then((res) => {
          debugger;
          this.bhsrArray = res.data;

          this.getUserManagerOuList();
        });
      },
      //保存
      async updateOuRoleUserList() {
        let data = {
          ou_name: this.bhsreditObj.bhsrname,
          user_id: this.$store.getters.getUser.user_id,
          user_list: this.bhsreditObj.vipname,
          tenant_id: this.$store.getters.getUser.tenant_id,
          ou_id: this.tData.ou_id,
        };
        debugger;
        await http.post("/wapi/v1/updateOuRoleUserList", data).then((res) => {
          this.editdialogVisible = false;
          this.bhsrArray = res.data;
        });
      },
      async updateOuUserList() {
        let data = {
          ou_list: this.bhsrObj.bhsrafter,
          user_id: this.$store.getters.getUser.user_id,
          opera_user_id: this.opera_user_id,
          tenant_id: this.$store.getters.getUser.tenant_id,
        };
        debugger;
        await http.post("/wapi/v1/updateOuUserList", data).then((res) => {
          this.showModal4 = false;
        });
      },
      bhsredit() {
        this.bhsreditObj.bhsrname = this.tableDataName;
        this.editdialogVisible = true;
        this.bhsrArray = [];
        this.bhsreditObj.vipname = [];
        this.getUserListByOu();
      },
      colse2() {
        this.showModal3 = false;
        this.$refs["phone"].resetFields();
      },
      colse4() {
        this.showModal4 = false;
      },
      baocun2() {
        this.$refs["phone"].validate((valid) => {
          if (valid) {
            // this.addOU()
            this.changePhone();
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      },
      async changePhone() {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          modified_by: this.$store.getters.getUser.user_id,
          user_id: this.formlist.user_id,
          phone: this.phoneObj.phone,
          oldPhone: this.oldPhone,
        };
        let self = this;
        await http.post("/wapi/v1/changePhone", data).then((res) => {
          if (res.success) {
            debugger
            if (res.data.data == "EXIST") {

                Message({
                  type: "error",
                  message: "电话号码已存在,请重新输入",
                });

            } else {
              this.tableDataRow.phone = this.phoneObj.phone;
              this.colse2();
              Message({
                type: "success",
                message: "保存成功!",
              });
            }
          } else {
            Message.error(res.message);
          }
        });
      },
      async search(queryString, cb) {
        this.queryString = queryString.trim();
        this.input = queryString.trim();
        if (queryString) {
          try {
            var user = this.$store.getters.getUser;
            let data = {
              tenant_id: user.tenant_id,
              search: this.queryString.trim(),
            };
            // console.log(data)
            await http.post("/wapi/Institution/searchPeopleList", data).then((res) => {
              if (res.success) {
                // console.log(res.data)
                cb(res.data);
              }
            });
          } catch (err) {
            this.error();
          }
        } else {
          cb([]);
          this.$refs.tree.filter();
        }
      },
      handleSelect(obj) {
        this.searchObj = obj;
        if (obj.ou_name) {
          //人员 / 号码
          this.ou_name = obj.ou_name.split("-")[1];

          this.input = this.queryString;
          var user = this.$store.getters.getUser;
          let data = {
            tenant_id: user.tenant_id,
            ou_id: obj.ou_id,
          };
          http.post("/wapi/Institution/getOuNameList", data).then((res) => {
            if (res.success) {
              console.log(res);
              this.depart = res.data;
              let department = {};
              department.key = this.depart[0].ou_id;
              this.currentNodeKey = department.key;
              this.depart[0].label = this.ou_name;
              // console.log(this.depart[0], department)
              this.handleNodeClick(this.depart[0], department);
              this.$refs.tree.setCurrentKey(department.key);
            }
          });
          this.$refs.tree.filter(this.ou_name);
        } else {
          //部门

          var str = obj.value.split("-")[1];
          if (str) {
            this.ou_name = obj.value.split("-")[1];
          } else {
            this.ou_name = obj.value; //总部
          }
          this.input = this.queryString;
          var user = this.$store.getters.getUser;
          let data = {
            tenant_id: user.tenant_id,
            ou_id: obj.ou_id,
          };
          http.post("/wapi/Institution/getOuNameList", data).then((res) => {
            if (res.success) {
              this.depart = res.data;
              let department = {};
              department.key = this.depart[0].ou_id;
              this.currentNodeKey = department.key;
              this.depart[0].label = this.ou_name;
              // console.log(this.depart[0], department)
              this.handleNodeClick(this.depart[0], department);
              this.$refs.tree.setCurrentKey(department.key);
            }
          });
          this.$refs.tree.filter(this.ou_name);
        }
      },
      //数据格式转换
      obj_to_arr(names, data) {
        return data.map((item) => {
          let arr = [];
          names.forEach((name) => {
            arr.push(item[name]);
          });
          return arr;
        });
      },
      downloadErrorExcel(header, data, page = 0, limit = 5000) {
        try {
          if (page * limit >= data.length) {
            return true;
          }

          //错误数据
          let tHeader = header;
          let tData = data.slice(page * limit, (page + 1) * limit);
          export_json_to_excel({
            header: tHeader,
            data: tData,
            filename: "报错信息表" + (!page ? "" : page),
          });
          this.loadingText = `正在下载错误数据0% (${(page + 1) * limit} / ${data.length})`;
          this.downloadErrorExcel(header, data, page + 1, limit);
        } catch (err) {
          this.loading = false;
          this.loadingText = "拼命加载中";
          this.$message.error("下载失败！");
        }
      },
      handleExportData() {
        try {
          this.loading = true;
          const tHeader = [
            "所属部门",
            "上级部门",
            "工号",
            "姓名",
            "性别",
            "出生日期",
            "手机",
            "电子邮件",
            "职务",
            "入职日期",
            "离职日期",
            "角色",
            "是否管理人员",
            "是否在职",
            "用户名",
            "报错信息",
          ];
          let names = [
            "ou_name",
            "parent_ou_name",
            "code",
            "user_name",
            "gender",
            "birthday",
            "phone",
            "emali",
            "title",
            "inductionDate",
            "departureDate",
            "role",
            "isManager",
            "status",
            "crm_name",
            "message",
          ];
          let data = this.obj_to_arr(names, this.errData);
          this.loadingText = `正在下载错误数据0% (0 / ${data.length})`;
          this.downloadErrorExcel(tHeader, data, 0, 20000);
          //错误数据
          this.loading = false;
          this.loadingText = "拼命加载中";
        } catch (err) {
          this.loading = false;
          this.loadingText = "拼命加载中";
          this.$message.error("下载失败！");
        }
      },
      // handleExportData() {
      //   try {
      //     import('@/vendor/Export2Excel').then(excel => {
      //       const tHeader = ['所属部门', '工号', '姓名', '性别', '出生日期', '手机', '电子邮件', '职务', '入职日期', '离职日期', '角色',
      //         '是否部门主管',
      //         '是否在职',
      //         '用户名',
      //         '密码',
      //         '报错信息']
      //       const filterVal = [
      //         'ou_name',
      //         'code',
      //         'user_name',
      //         'gender',
      //         'birthday',
      //         'phone',
      //         'emali',
      //         'title',
      //         'inductionDate',
      //         'departureDate',
      //         'role',
      //         'isManager',
      //         'status',
      //         'crm_name',
      //         'passWord',
      //         'message'
      //       ]
      //       let arr = [...this.arr]
      //       for (var i = 0; i < arr.length; i++) {
      //         let obj = arr[i].message.join(" ")
      //         arr[i].message = obj
      //       }
      //
      //       const list = arr
      //       const data = this.formatJson(filterVal, list)
      //
      //       excel.export_json_to_excel({
      //         header: tHeader,
      //         data,
      //         filename: '报错信息表',
      //         autoWidth: this.autoWidth
      //       })
      //     })
      //     this.loading = false
      //     this.showModal2 = false
      //   } catch (err) {
      //     this.loading = false
      //     this.error()
      //   }
      // },
      formatJson(filterVal, jsonData) {
        return jsonData.map((v) => filterVal.map((j) => v[j]));
      },
      showPeople() {
        var user = this.$store.getters.getUser;
        if (this.filterText) {
          let data = {
            tenant_id: user.tenant_id,
            search: this.filterText,
          };
          http.post("/wapi/Institution/searchPeopleList", data).then((res) => {
            if (res.success == true) {
              // console.log(res.data, 55)
              if (res.data[0].ou_name) {
                this.val1 = res.data[0].ou_name;
                this.$refs.tree.filter(this.val1);
              } else {
                this.val1 = res.data;
                this.$refs.tree.filter(this.val1);
              }
            }
          });
        } else {
          // let data = {
          //     tenant_id: user.tenant_id,
          // }
          // http.post('/wapi/v1/getOuList', data).then(res => {
          //     if(res.success == true){
          //         this.data = res.data
          //     }
          // })
        }
      },
      showModalAction() {
        if (this.updataActive2) {
          this.fileList = [];
          this.showModal = true;
        }
      },
      // 关闭模态框
      closeModal() {
        this.fileList = [];
        this.excelData = [];
        this.showModal = false;
        this.isUpload = false;
      },
      filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
      //导出用户列表
      async exportUserList() {
        this.loading = true;
        await axios({
          method: "post",
          url: "/wapi/v1/exportUserList",
          data: {
            tenant_id: this.$store.getters.getUser.tenant_id,
          },
          responseType: "arraybuffer",
        }).then((res) => {
          // if (res.status == 200 && res.data.size) {
          // var uInt8Array = new Uint8Array(res); //先将返回的二进制数组转化为js的二进制数组
          debugger;
          let blob = new Blob([res.data], { type: "application/vnd.ms-excel" }); //然后创建blob对象，文件类型设置为excel的类型

          const fileName = "人员.xlsx";

          const elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
          // } else {
          //   this.$message.error('下载失败')
          // }
          this.loading = false;
        });
      },
      async getParsingFile(fileName) {
        return new Promise(function (resolve, reject) {
          //定义reader，存放文件读取方法
          let reader = new FileReader();

          //启动函数
          reader.readAsBinaryString(fileName);
          //onload文件读取成功
          reader.onload = function (e) {
            //workbook存放excel的所有基本信息
            let workbook = xlsx.read(e.target.result, { type: "binary" });
            xlsx.onprogress = function (e) { };
            //定义sheetList中存放excel表格的sheet表，就是最下方的tab
            let sheetList = workbook.SheetNames;

            //存放json数组格式的表格数据
            let resultJson = [];
            if (sheetList.length > 1) {
              reject({ status: false, message: "模板错误,不能有1个以上sheet" });
            }
            sheetList.forEach(function (y) {
              let worksheet = workbook.Sheets[y];
              resultJson = xlsx.utils.sheet_to_json(workbook.Sheets[y], { defval: "" });
            });
            if (resultJson.length === 0) {
              resolve({ status: true, data: resultJson });
            }
            //取出表头
            let tableHeader = Object.keys(resultJson[0]);

            //取出表数据
            let importInfo = resultJson.map((item) => {
              return tableHeader.map((v) => item[v]);
            });

            importInfo = [tableHeader, ...importInfo];
            resolve({ status: true, data: importInfo });
          };
          //文件读取失败
          reader.onerror = function (e) {
            reject({ status: false, message: "解析失败" });
          };
        });
      },
      async handleChange(file, fileList) {
        this.loading = true;
        this.$refs.upload.clearFiles();
        this.loadingText = "文件解析中";
        let res = await this.getParsingFile(file.raw);
        setTimeout(() => {
          this.loading = false;
          this.loadingText = "拼命加载中";
        }, 1000);

        if (!res.status) {
          this.$message.error(res.message);
          this.fileList = [];
          return;
        }

        if (res.data.length === 0 || res.data[0][0].trim() !== "所属部门" || res.data[0].length !== 22) {
          this.$message.error("模板错误，请选择正确的模板");
          this.fileList = [];
          return false;
        }
        if (res.data.slice(1).length === 0) {
          this.$message.error("导入数据必须大于0条");
          this.fileList = [];
          return false;
        }
        if (fileList.length !== 0 && res) {
          this.file = file.name;
        }
        this.excelData = res.data;
      },
      // handleChange(file, fileList) {
      //
      //     this.file = file.name
      //     const nameArr = file.name.split('.')
      //     const extension = nameArr[nameArr.length - 1] === 'xlsx'
      //     const isLt2M = file.size / 1024 / 1024 < 10
      //     if (!extension) {
      //         this.file = ''
      //         this.fileList = []
      //         Message({
      //             showClose: true,
      //             message: '上传模板只能是xlsx',
      //             type: 'error'
      //         })
      //     }
      //     if (!isLt2M) {
      //         this.file = ''
      //         this.fileList = []
      //         Message({
      //             showClose: true,
      //             message: '传模板大小不能超过 10MB',
      //             type: 'error'
      //         })
      //     }
      //     this.isUpload = true
      //
      //     return extension && isLt2M
      // },
      async handleSuccess(res, file) {
        // console.log(res)

        const loading = this.$loading({
          lock: true,
          text: "拼命加载中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        if (res.success) {
          try {
            var user = this.$store.getters.getUser;

            let data = {
              tenant_id: user.tenant_id,
              user_id: user.user_id,
              path: res.data,
              ou_id: this.ou_id,
            };

            await http.post("/wapi/excel/imortUserOu", data).then((res) => {
              loading.close();
              if (res.success) {
                this.closeModal();
                let msg = "";
                //                                if(res.msg && res.msg.length>0){
                //
                //                                    res.msg.forEach(item=>{
                //                                        msg+=item[0]+','
                //                                    })
                //                                }
                if (res.data) {
                  if (res.data.length == 0) {
                    this.show = false;
                    Message({
                      type: "success",
                      message: "导入成功",
                    });
                  } else {
                    this.showModal2 = true;
                    this.hcpArray = [...res.data];
                    this.arr = [...res.data];
                    this.numSuccess = res.numSuccess;
                    this.errorText = res.errorText;
                    this.numError = res.numError;
                  }
                } else {
                  Message({
                    type: "error",
                    message: res.message,
                  });
                }

                this.getUserOuList(this.tData);
              } else {
                this.fileList = [];

                if (res.type && res.type === "warning") {
                  Message({
                    type: "error",
                    message: res.message,
                  });
                } else {
                  Message({
                    type: "error",
                    message: "导入失败",
                  });
                }
              }

              this.loading = false;
            });
          } catch (err) {
            loading.close();
            // this.fileSecond = ''
            this.fileListSecond = [];
            Message.error("导入失败！");
          }
        } else {
          loading.close();
          // this.fileSecond = ''
          this.fileListSecond = [];
          Message.error("导入失败！");
        }
      },
      handleRemove(file, fileList) {
        this.isUpload = false;
      },
      //导入数据
      async importData(herder, excelData = [], page = 0, limit = 1000, size = 0) {
        try {
          if (page * limit >= size) {
            return true;
          }
          let data = {
            progressNum: page * limit,
            tenant_id: this.$store.getters.getUser.tenant_id,
            user_id: this.$store.getters.getUser.user_id,
            data: [herder, ...excelData.slice(page * limit, (page + 1) * limit)],
          };

          let response = await http.post("/wapi/excel/imortUserOu", data);
          debugger;
          if (response.statusCode === 502) {
            return await this.importData(herder, excelData, page, limit, size);
          }
          if (!response) {
            return false;
          }

          this.loadingText = "正在导入数据" + (((page + 1) * limit) / size > 1 ? "100%" : ((((page + 1) * limit) / size) * 100).toFixed(0) + "%");
          let progressText = (page + 1) * limit >= size ? ` (${size} / ${size})` : ` (${(page + 1) * limit} / ${size})`;
          this.loadingText += progressText;
          if (response.success) {
            this.record.push(true);
            if (response.data) {
              if (!this.errData || this.errData.length == 0) {
                this.errData = [];
              }
              this.errData = [...this.errData, ...response.data];
            }
          } else {
            this.record.push(false);
            if (response.data) {
              if (!this.errData || this.errData.length == 0) {
                this.errData = [];
              }
              this.errData = [...this.errData, ...response.data];
            }
          }
          return await this.importData(herder, excelData, page + 1, limit, size);
        } catch (e) {
          return false;
        }
      },
      async imortDataClick() {
        if (this.excelData.length === 0) {
          this.$message.error("请选择导入模板！");
          return false;
        }
        this.loading = true;
        this.loadingText = `正在导入数据0% (0 / ${this.excelData.length - 1})`;
        this.errData = "";
        let herder = this.excelData[0];

        debugger;
        let res = await this.importData(herder, this.excelData.slice(1), 0, 500, this.excelData.length - 1);
        debugger
        if (!res) {
          this.$message.error("导入失败");
          this.loading = false;
          this.loadingText = "拼命加载中";
        } else {
          if (this.record.some((item) => item)) {
            this.$message.success("导入成功");
            await this.getUserOuList(this.tData);
            this.loadingText = "拼命加载中";
            this.loading = false;
            if (this.errData.length > 0) {
              this.showModal2 = true;
              this.hcpArray = this.errData.slice(0, 100);
            }
          } else {
            this.$message.error("导入失败");
            this.loading = false;
            this.loadingText = "拼命加载中";
            if (this.errData.length > 0) {
              this.showModal2 = true;
              this.hcpArray = this.errData.slice(0, 100);
            }
          }
        }
      },
      // imortDataClick() {
      //     if (this.isUpload) {
      //         this.$refs.upload.submit()
      //     } else {
      //         Message({
      //             showClose: true,
      //             message: '导入模板不能为空',
      //             type: 'error'
      //         })
      //     }
      // },

      //添加、编辑
      addOpen(on, operate) {
        if (this.updataActive3) {
          this.bianB = on;

          if (operate === "添加部门") {
            this.form.eBname = "";
            this.dialogFormVisible = true;
            this.baocun = 1;
            this.dialogTitler = "添加部门";
          } else if (operate === "编辑部门") {
            if (this.updataActive2) {
              this.form.eBname = this.formeBname;

              this.dialogFormVisible = true;

              this.baocun = 2;
              this.dialogTitler = "部门详情";
            }
          }
        }
      },
      phoneDetails(row) {
        this.showModal3 = true;
        this.oldPhone = row.phone;
        this.phoneObj.phone = "";
      },
      roleDetails(row) {
        this.showModal4 = true;
        this.bhsrObj.bhsrafter = [];
        this.bhsrObj.bhsrbefore = [];
        debugger;
        this.getOuListNotTree();
        this.getOuByUserList(row.user_id);
      },
      async getOuByUserList(item) {
        this.opera_user_id = item;
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          user_id: item,
        };
        debugger;
        await http.post("/wapi/v1/getOuByUserList", data).then((res) => {
          for (let i = 0; i < res.data.length; i++) {
            let ou_id = res.data[i].ou_id;
            debugger;
            this.bhsrObj.bhsrbefore.push(ou_id);
          }
        });
      },
      
      async changeWecomIdByName1(value)
      {
        let wecom_id = await this.getUserWecomId(value);
        this.addForm.wecom_id = wecom_id;
      },
      async changeWecomIdByName2(value)
      {
        console.log(value);
        let wecom_id = await this.getUserWecomId(value);
        console.log(wecom_id);
        this.formlist.wecom_id = wecom_id;
      },
      //从临时表获取企业微信id
      async getUserWecomId(alias)
      {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          alias: alias,
        };
        let result ="";
        await http.post("/crm/users/admin/getUserWecomIdByName", data).then((res) => {
          console.log(res);
          result = res.data.data;
        });

        return result;
      },
      
      async changeUserVoovIdByPhone1(value)
      {
        let om_user_id = await this.getUserVoovUserIdByPhone(value);
        this.addForm.om_user_id = om_user_id;
      },
      //从临时表获取腾讯会议id
      async getUserVoovUserIdByPhone(phone)
      {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          phone: phone,
        };
        let result ="";
        await http.post("/crm/users/admin/getUserVoovUserIdByPhone", data).then((res) => {
          console.log(res);
          result = res.data.data;
        });

        return result;
      },
      //取消
      resetForm() {
        this.dialogFormVisible = false;
        this.$refs["ruleForm2"].resetFields();
        this.dialogFormVisible = false;
      },
      //保存按钮
      openSubmit() {
        //添加部门
        if (this.baocun === 1) {
          this.$refs["ruleForm2"].validate((valid) => {
            if (valid) {
              this.addOU();
            } else {
              console.log("error submit!!");
              return false;
            }
          });
        } else if (this.baocun === 2) {
          //编辑部门

          this.updateOU();
        }
      },

      //点击部门
      handleNodeClick(data, node) {
        this.page = {
          current: 1,
          size: 10,
          total: 0,
        };
        this.treeDataNode = node.data;
        console.log(data, node);
        this.show = false;

        this.addForm.ou_id = data.ou_id;
        this.addForm.bname = data.ou_name;
        this.bname = data.ou_name;
        this.bname_ou_id = data.ou_id;
        this.tabActive = false;
        this.updataActive3 = true;
        this.treeKey = node.key;
        this.radio = 0;
        // this.mynode = node
        //判断部门下是否有部门
        /* if(data.children.length > 0){
                       this.updataActive=false
                   }*/
        this.$nextTick(() => {
          if (data.children.length > 0) {
            // this.updataActive=false
            this.onOffupdataActive = false;
          } else {
            // this.updataActive=true
            this.onOffupdataActive = true;
          }
        });
        this.tableDataName = data.label;
        this.formeBname = data.label;
        this.ou_id = data.ou_id;
        this.parent_ou_id = node.parent ? node.parent.data.ou_id : data.parent_ou;
        this.tenant_id = data.tenant_id;
        this.tData = data;

        this.getUserOuList(data);
        let a = this.$refs.tree.getCurrentKey();
        if (a) {
          // this.updataActive = true
          this.updataActive2 = true;
          this.onOffupdataActive = true;
          // console.log(2)
        } else {
          // console.log(1)
          // this.updataActive = false
          this.updataActive2 = false;
          this.onOffupdataActive = false;
        }
        //清空关联数据
        this.tableDataRow.name = "";
        this.tableDataRow.sex = "";
        this.tableDataRow.birthday = "";
        this.tableDataRow.phone = "";
        this.tableDataRow.duty = "";
        this.tableDataRow.role = [];
        this.tableDataRow.project_array = [];
        this.tableDataRow.project_item_array = [];
        this.myZhuGuan = "";
        this.myStatus = "";

        // console.log(node.key)
        this.$nextTick(function () {
          // this.$refs.tree3.setCurrentKey();
          this.$refs.tree.setChecked(node.key, true, false); //"treeList"是你自己在树形控件上设置的 ref="treeList" 的名称
        });
      },
      // eslint-disable-next-line no-unused-vars
      handleNodeClick2(data, node) {
        // eslint-disable-next-line no-

        this.form.ou_id = data.ou_id;

        this.form.bname = data.ou_name;
        this.formlist.ou_id = data.ou_id;

        this.formlist.department = data.ou_name;
        debugger;
      },
      handleClick2(data, node) {
        this.bhsrObj.after = data.ou_name;
        debugger;
      },
      handleNodeClick3(data, node) {
        this.addForm.ou_id = data.ou_id;
        this.addForm.bname = data.ou_name;
      },

      //删除
      deleteOpen() {
        if (this.updataActive) {
          MessageBox.confirm("移除该部门, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.deleteOU();
            })
            .catch(() => {
              Message({
                type: "info",
                message: "已取消删除",
              });
            });
        }
      },

      append(data) {
        const newChild = { id: id++, label: "testtest", children: [] };
        if (!data.parent_ou) {
          this.$set(data, "children", []);
        }
        data.children.push(newChild);
      },

      remove(node, data) {
        const parent = node.parent;
        const children = parent.data.children || parent.data;
        const index = children.findIndex((d) => d.id === data.id);
        children.splice(index, 1);
      },

      // //分页
      // handleSizeChange(val) {
      //     this.pageSize = val
      // },
      // handleCurrentChange(val) {
      //     this.pageIndex = val
      // },
      // 改变页码信息
      changePageClick(page, size) {
        if (page) {
          this.page.current = page;
        }
        if (size) {
          this.page.size = size;
        }
        this.getUserOuList(this.tData);
      },

      //获取部门列表
      async getOU(type, ou_id) {
        const loading = this.$loading({
          lock: true,
          text: "拼命加载中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        try {
          let user = this.$store.getters.getUser;
          let data = {
            tenant_id: user.tenant_id,
          };
          /*
                      const res1 = await   request.post(`http://localhost:17000/wapi/v1/getOuList`,data);*/
          // await Vue.axios.post("http://localhost:17000/wapi/v1/getOuList",qs.stringify(data)).then((response)=>{
          //     console.log(response.data);//成功回调
          // },(response)=>{
          //     //失败回调
          //
          //     console.log(err)
          //
          // })

          await http.post("/wapi/v1/getOuList", data).then((res) => {
            loading.close();

            if (res.success) {
              if (type === "add") {
                setTimeout(() => {
                  this.$refs.tree.setCurrentKey(ou_id);
                  let transObj = this.$refs.tree.getCurrentNode();
                  let transNode = this.$refs.tree.getNode(transObj.ou_id);
                  this.handleNodeClick(transObj, transNode);
                }, 100);
              } else {
                setTimeout(() => {
                  this.$refs.tree.setCurrentKey(this.treeKey);
                }, 100);
              }
              this.data = res.data;

              // this.getUserOuList(this.data,'default')
              if (type === "del") {
                this.defaultExpandedKeys.push(this.parent_ou_id);
              } else {
                this.defaultExpandedKeys.push(this.ou_id);
              }
              // console.log(this.defaultExpandedKeys)
              this.$nextTick().then(() => {
                const firstNode = document.querySelector(".el-tree-node");
                // console.log(firstNode)
                if (type) {
                } else {
                  firstNode.click();
                }
              });
            }
          });
        } catch (err) {
          loading.close();
          Message.error("获取失败！");
        }
      },

      //部门员工
      async getUserOuList(Tdata, type) {
        const loading = this.$loading({
          lock: true,
          text: "拼命加载中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        try {
          if (type === "default") {
            Tdata = Tdata[0];
          }

          let user = this.$store.getters.getUser;
          let data = {
            tenant_id: user.tenant_id,
            ou_id: Tdata.ou_id,
            pageIndex: this.page.current,
            pageSize: this.page.size,
            searchObj: this.searchObj,
          };

          await http.post("/wapi/v1/getUserOuList", data).then((res) => {
            loading.close();
            if (res.success) {
              console.log(res.data, 878);

              //部门下有员工不能删除部门
              this.$nextTick(() => {
                if (res.data.length > 0) {
                  this.updataActive = false;
                } else {
                  this.updataActive = this.onOffupdataActive;
                }
              });
              this.page.total = parseInt(res.count);
              this.tableData = [];

              res.data.forEach((item) => {
                let sex = "";
                if (item.gender === "M") {
                  sex = "男";
                } else if (item.gender === "F") {
                  sex = "女";
                } else {
                  sex = "";
                }

                let obj = {
                  rowIndex: parseInt(item.rowindex),
                  user_id: item.user_id,
                  name: item.last_name,
                  employee_code: item.employee_code,
                  onboard_date: item.onboard_date,
                  leave_date: item.leave_date,
                  department: item.department,
                  comments: item.comments ? item.comments : "",
                  sex: sex,
                  birthday: item.birthday,
                  username: item.username,
                  password: item.password,
                  email: item.email,
                  duty: item.title,
                  phone: item.phone,
                  status: item.status,
                  role: item.roles,
                  //zhuGuan: item.role,
                  //isZhuGuan: item.role === 'MANAGER' ? '是' : '否',
                  zhuGuan: item.manager == "T" ? "MANAGER" : "STAFF",
                  isZhuGuan: item.manager == "T" ? "是" : "否",
                  key_id: item.key_id,
                  outsourcing_user: item.outsourcing_user,
                  supplier_id: item.supplier_id,
                  supplier_user: item.supplier_user,
                  om_user_id: item.om_user_id,
                  wecom_id: item.wecom_id,
                  project_array: item.project_array,
                  project_item_array: item.project_item_array,
                  checkin_random: item.checkin_random
                };
                this.tableData.push(obj);
              });
              this.searchObj = {};
            }
          });
        } catch (err) {
          loading.close();
          Message.error("获取失败！");
        }
      },
      //编辑员工
      async updateUserOu() {
        try {
          let user = this.$store.getters.getUser;
          let sex = "";
          if (this.formlist.sex == "男") {
            sex = "M";
          } else if (this.formlist.sex == "女") {
            sex = "F";
          } else {
            sex = "";
          }
          if(this.formlist.checkin_random && (this.formlist.checkin_random<0||this.formlist.checkin_random>1)){
              Message({
                type: "error",
                message: "签到参数为0-1之间",
              });
            return
          }
          // let pattern = /[^\w]/g
          // if (pattern.test(this.formlist.username)) {
          //   Message({
          //     type: 'error',
          //     message: '用户名只能包含字母,数字,下划线'
          //   });
          //   return false;
          // }

          let data = {
            title: this.formlist.duty,
            modified_by: this.$store.getters.getUser.user_id,
            user_id: this.formlist.user_id,
            key_id: this.formlist.key_id,
            department: this.formlist.department,
            onboard_date: this.formlist.onboard_date ? this.formlist.onboard_date : "",
            leave_date: this.formlist.leave_date ? this.formlist.leave_date : "",
            employee_code: this.formlist.employee_code,
            comments: this.formlist.comments ? this.formlist.comments : "",
            gender: sex,
            phone: this.formlist.phone,
            status: this.formlist.status,
            alias: this.formlist.last_name,
            role: this.formlist.zhuGuan,
            update_user: user.user_id,
            tenant_id: user.tenant_id,
            ou_id: this.formlist.ou_id ? this.formlist.ou_id : this.tData.ou_id,
            // ou_id: this.formlist.ou_id,
            old_ou_id: this.tData.ou_id,
            roles: this.formlist.role,
            username: this.formlist.username,
            password: this.formlist.password,
            email: this.formlist.email,
            supplier_id: this.formlist.supplier_id,
            supplier_user: this.formlist.supplier_user,
            outsourcing_user: this.formlist.outsourcing_user,
            wecom_id: this.formlist.wecom_id,
            om_user_id: this.formlist.om_user_id,
            project_array: this.formlist.project_array,
            checkin_random: this.formlist.checkin_random,
          };
          if (data.password == this.selectUser.password) {
            delete data.password;
          }
          debugger;
          // let res = await http.post('/wapi/v1/updateUserOu', data)
          await http.post("/wapi/v1/updateUserOu", data).then((res) => {
            // loading.close()
            if (res.success) {
              //
              // console.log(res.data)
              if (res.data.data === "EXIST") {
                Message({
                  type: "error",
                  message: "用户名已存在",
                });
              } else if (res.data.data === "EXISTCODE") {
                Message({
                  type: "error",
                  message: "工号不能重复",
                });
              } else {
                if (res.data[0].ou_id !== this.ou_id) {
                  this.$nextTick(() => {
                    this.radio = 0;
                    this.tabActive = false;
                    //清空关联数据
                    this.tableDataRow.name = "";
                    this.tableDataRow.sex = "";
                    this.tableDataRow.birthday = "";
                    this.tableDataRow.email = "";
                    this.tableDataRow.username = "";
                    this.tableDataRow.password = "";
                    this.tableDataRow.phone = "";
                    this.tableDataRow.duty = "";
                    this.tableDataRow.role = [];
                    this.tableDataRow.project_array = [];
                    this.tableDataRow.project_item_array = [];
                    this.myZhuGuan = "";
                    this.myStatus = "";
                  });
                }

                this.getUserOuList(this.tData);

                let sex = "";
                if (res.data[0].gender === "M") {
                  sex = "男";
                } else if (res.data[0].gender === "F") {
                  sex = "女";
                } else {
                  sex = "";
                }
                let obj = {
                  rowIndex: parseInt(res.data[0].rowindex),
                  user_id: res.data[0].user_id,
                  department: res.data[0].department,
                  employee_code: res.data[0].employee_code,
                  onboard_date: res.data[0].onboard_date,
                  leave_date: res.data[0].leave_date,
                  comments: res.data[0].comments,
                  name: res.data[0].last_name,
                  sex: sex,
                  birthday: res.data[0].birthday,
                  username: res.data[0].username,
                  password: res.data[0].password,
                  email: res.data[0].email,
                  duty: res.data[0].title,
                  phone: res.data[0].phone,
                  status: res.data[0].status,
                  role: res.data[0].roles,
                  zhuGuan: res.data[0].role,
                  project_array: res.data[0].project_array,
                  project_item_array: res.data[0].project_item_array,
                  checkin_random: res.data[0].checkin_random,
                };
                console.log(obj)
                // this.rowClick(obj)
                this.form.user_id = obj.user_id;
                this.myStatus = obj.status === "ACTIVE" ? "在职" : "离职";

                if (obj.zhuGuan === "STAFF") {
                  this.myZhuGuan = "否";
                } else if (obj.zhuGuan === "MANAGER") {
                  this.myZhuGuan = "是";
                }
                this.tableDataRow = obj;
                this.dialogFormVisible = false;
                Message({
                  type: "success",
                  message: "保存成功!",
                });
                this.dialogVisible2 = false;
                // this.page.total = parseInt(res.count)
                // this.tableData=[]
                // res.data.forEach(item=>{
                //
                //     let obj={
                //         rowIndex : parseInt(item.rowindex),
                //         name: item.last_name,
                //         sex: item.gender,
                //         birthday: item.birthday,
                //         duty: item.title,
                //         phone: item.phone,
                //         status: item.status,
                //         role: item.roles,
                //         zhuGuan: item.role,
                //     }
                //     this.tableData.push(obj)
                // })
              }
            } else {
              Message.error("保存失败！");
            }
          });
        } catch (err) {
          console.log(err);
          // loading.close()
          Message.error("保存失败！");
        }
      },

      //新增员工
      async addUserOu() {
        const loading = this.$loading({
          lock: true,
          text: "拼命加载中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        try {
          let user = this.$store.getters.getUser;

          let sex = "";
          if (this.addForm.sex == "男") {
            sex = "M";
          } else if (this.addForm.sex == "女") {
            sex = "F";
          } else {
            sex = "";
          }
          if (this.myZhuGuan == false) {
            this.myZhuGuan = "STAFF";
          } else {
            this.myZhuGuan = "MANAGER";
          }
          // let pattern = /[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/im;
          // if (pattern.test(this.addForm.username)) {
          //     Message({
          //         type: 'error',
          //         message: '用户名包含特殊字符'
          //     });
          //     return false;
          // }

          // let data = {
          //     title: this.addForm.duty,
          //     user_id: this.addForm.user_id,
          //     gender: sex,
          //     phone: this.addForm.phone,
          //     birthday: this.addForm.birthday,
          //     status: this.addForm.status,
          //     user_name: this.addForm.name,
          //     role: this.addForm.zhuGuan,
          //     update_user: user.user_id,
          //     tenant_id: user.tenant_id,
          //     ou_id: this.addForm.ou_id?this.addForm.ou_id:this.tData.ou_id,
          //     roles: this.addForm.role
          // }
          let obj = {
            sendMethod: "SMS",
            tenant_type: "CRM",
            phone: this.addForm.phone,
            alias: this.addForm.name,
            gender: sex,
            email: this.addForm.email,
            // birthday: this.addForm.birthday,
            role: this.addForm.zhuGuan,
            bind_ou_id: this.addForm.ou_id,
            title: this.addForm.duty,
            employee_code: this.addForm.employee_code,
            tenant_id: user.tenant_id,
            tenant_name: "121",
            form_role: this.addForm.role,
            from_user_id: user.user_id,
            from_tenant_id: user.tenant_id,
            from_alias: user.alias,
            status: this.addForm.status,
            username: this.addForm.username,
            password: this.addForm.password,
            supplier_id: this.addForm.supplier_id,
            supplier_user: this.addForm.supplier_user,
            outsourcing_user: this.addForm.outsourcing_user,
          };
          // console.log(obj)
          let data = {
            service_id: "crm_server",
            data: JSON.stringify(obj),
            tenant_id: user.tenant_id,
            user_id: user.user_id,
            client_id: "com.saasyun.android",
            client_secret: "0a4da4e6-e36a-4e78-b4fc-78bb62aa9ff4",
            token: "742fcc1c-9221-afa0-d043-c7b1724250c8",
            username: user.username,
            product_id: "CRM",
            tenant_type: "CRM",
          };
          // let res = await http.post('/wapi/v1/updateUserOu', data)
          // let Body = new FormData()
          // Body.append('client_secret', '0a4da4e6-e36a-4e78-b4fc-78bb62aa9ff4')
          // Body.append('client_id', 'com.saasyun.android')
          // Body.append('tenant_id',  '4747530849')
          // Body.append('service_id', 'crm_server')
          // Body.append('token', '742fcc1c-9221-afa0-d043-c7b1724250c8')
          // Body.append('username', "2059087476")
          // Body.append('data', JSON.stringify(obj))
          // let url ='/emsTest'+'/tenantServer/addPersonnel'
          //
          // console.log(url)
          // var config = {
          //     headers: {'Access-Control-Allow-Origin': '*'}
          // };  //添加请求头
          // let dataOne = qs.stringify(data)
          // await http.post(url, dataOne).then(
          //     response => {
          //     console.log(1)
          //     console.log(response)
          //     })
          //let dataOne = JSON.stringify(data)
          // console.log(Body)
          // this.radio = 0;
          // this.tabActive = false
          // //清空关联数据
          // this.addForm.name = ''
          // this.addForm.sex = ''
          // this.addForm.birthday = ''
          // this.addForm.phone = ''
          // this.addForm.duty = ''
          // this.addForm.role = []
          // this.myZhuGuan = false
          // this.myStatus = false
          // this.addForm.bname = ''
          // console.log(data)
          // console.log(data)
          // console.log(obj)
          // return
          await http.post("/wapi/v1/addUser", data).then((res) => {
            if (!res.success) {
              this.$message({
                type: "error",
                message: res.message,
              });
              loading.close();
              // this.dialogFormVisible2 = false
              return;
            }
            (this.addForm = {
              user_id: "",
              //员工名
              name: "",
              employee_code: "",
              //所属部门
              bname: "",
              options1: [],
              //性别
              sex: "",
              //生日
              // birthday: "",
              //手机
              phone: "",
              //职务
              duty: "",
              //角色
              role: [],
              options2: [],
              //状态
              status: "ACTIVE",
              //主管
              zhuGuan: "",
              ou_id: "",
              username: "",
              password: "",
              email: "",
            }),
              // console.log(this.tData)
              this.getUserOuList(this.tData);
            loading.close();
            this.dialogFormVisible2 = false;

            if (res.data[0].ou_id !== this.ou_id) {
              /*  setTimeout(()=>{
                                    this.radio=0;
                                    this.tabActive=false
                                    //清空关联数据
                                    this.tableDataRow.name = ''
                                    this.tableDataRow.sex = ''
                                    this.tableDataRow.birthday = ''
                                    this.tableDataRow.phone = ''
                                    this.tableDataRow.duty = ''
                                    this.tableDataRow.role = []
                                    this.myZhuGuan = ''
                                    this.myStatus = ''
                                    // this.$forceUpdate()
                                },200)*/
              this.radio = 0;
              this.tabActive = false;
              //清空关联数据
              this.addForm.name = "";
              this.addForm.sex = "";
              this.addForm.username = "";
              this.addForm.password = "";
              this.addForm.email = "";
              // this.addForm.birthday = ''
              this.addForm.phone = "";
              this.addForm.duty = "";
              this.addForm.role = [];
              this.addForm.status = "ACTIVE";
              this.myZhuGuan = false;
              this.myStatus = false;
            }

            /*this.tableDataRow.name=res.data[0].last_name
                          this.tableDataRow.sex=res.data[0].gender==='M'?'男':'女'
                          this.tableDataRow.birthday=res.data[0].birthday
                          this.tableDataRow.phone=res.data[0].phone
                          this.tableDataRow.duty=res.data[0].title
                          /!* this.form.role=this.tableDataRow.role.data*!/
                          this.tableDataRow.role = []
                          if (res.data[0].roles) {
                              for (let i = 0; i < res.data[0].roles.length; i++) {
                                  let role_id = res.data[0].roles[i].role_id
                                  this.tableDataRow.role.push(role_id)
                              }
                          } else {
                              this.tableDataRow.role = []
                          }
  
                          this.tableDataRow.status = res.data[0].status === "ACTIVE" ? true : false
                          if(res.data[0].role==='STAFF'){
                              this.tableDataRow.ZhuGuan=false
  
                          }else if(res.data[0].role==='MANAGER'){
                              this.tableDataRow.ZhuGuan=true
  
                          }*/

            let sex = "";
            if (res.data[0].gender === "M") {
              sex = "男";
            } else if (res.data[0].gender === "F") {
              sex = "女";
            } else {
              sex = "";
            }
            let obj = {
              rowIndex: parseInt(res.data[0].rowindex),
              user_id: res.data[0].user_id,
              name: res.data[0].last_name,
              sex: sex,
              birthday: res.data[0].birthday,
              duty: res.data[0].title,
              phone: res.data[0].phone,
              status: res.data[0].status,
              role: res.data[0].roles,
              zhuGuan: res.data[0].role,
            };
            // this.rowClick(obj)
            this.form.user_id = obj.user_id;
            this.myStatus = obj.status === "ACTIVE" ? "在职" : "离职";

            if (obj.zhuGuan === "STAFF") {
              this.myZhuGuan = "否";
              this.form.zhuGuan = false;
            } else if (obj.zhuGuan === "MANAGER") {
              this.myZhuGuan = "是";
              this.form.zhuGuan = true;
            }
            this.tableDataRow = obj;
            for (let key in this.addForm) {
              this.addForm[key] = "";
            }
            this.addForm.status = "ACTIVE";
            this.dialogFormVisible2 = false;
            this.$refs["ruleForm"].resetFields();
            Message({
              type: "success",
              message: "保存成功!",
            });
            // this.page.total = parseInt(res.count)
            // this.tableData=[]
            // res.data.forEach(item=>{
            //
            //     let obj={
            //         rowIndex : parseInt(item.rowindex),
            //         name: item.last_name,
            //         sex: item.gender,
            //         birthday: item.birthday,
            //         duty: item.title,
            //         phone: item.phone,
            //         status: item.status,
            //         role: item.roles,
            //         zhuGuan: item.role,
            //     }
            //     this.tableData.push(obj)
            // })
          });
        } catch (err) {
          // console.log(this.tData)
          this.getUserOuList(this.tData);
          // loading.close()
          // Message.error("保存失败！")
        }
      },

      //添加部门
      async addOU() {
        const loading = this.$loading({
          lock: true,
          text: "拼命加载中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        try {
          let user = this.$store.getters.getUser;
          let data = {
            parent_ou: this.ou_id,
            user_id: user.user_id,
            tenant_id: user.tenant_id,
            ou_name: this.form.eBname,
          };

          await http.post("/wapi/v1/addOu", data).then((res) => {
            loading.close();
            this.dialogFormVisible = false;

            if (res.success) {
              this.updataActive = false;
              this.updataActive2 = false;
              //  this.data.push(res.data[0])
              //
              //  let obj=res.data[0]
              // obj.label=res.data[0].ou_name
              //  obj.children=[]
              //  if(this.mynode){
              //
              //       this.mynode.childNodes.unshift(obj)
              //  }else {
              //      this.data.unshift(obj)
              //  }
              this.getOU("add", res.data[0].ou_id);

              Message({
                type: "success",
                message: "添加成功!",
              });
            } else {
              Message.error(res.message);
            }
          });
        } catch (err) {
          loading.close();
          Message.error("添加失败！");
        }
      },
      async deleteOU() {
        const loading = this.$loading({
          lock: true,
          text: "拼命加载中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        try {
          let user = this.$store.getters.getUser;
          let data = {
            ou_id: this.ou_id,
            user_id: user.user_id,
            tenant_id: user.tenant_id,
          };

          await http.post("/wapi/v1/deleteOu", data).then((res) => {
            loading.close();

            if (res.success) {
              this.form.eBname = "";
              this.tableDataName = "";
              this.tableData = [];
              this.updataActive = false;
              this.updataActive2 = false;

              this.getOU("del");
              Message({
                type: "success",
                message: "删除成功!",
              });
            }
          });
        } catch (err) {
          loading.close();
          Message.error("删除失败！");
        }
      },
      async updateOU() {
        const loading = this.$loading({
          lock: true,
          text: "拼命加载中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        try {
          let user = this.$store.getters.getUser;
          let data = {
            ou_name: this.form.eBname,
            ou_id: this.ou_id,
            user_id: user.user_id,
            tenant_id: user.tenant_id,
          };

          await http.post("/wapi/v1/updateOu", data).then((res) => {
            loading.close();

            if (res.success) {
              this.tableDataName = this.form.eBname;
              this.dialogFormVisible = false;
              this.formeBname = this.form.eBname;
              // this.getOU()

              this.treeDataNode.label = this.form.eBname;
              // console.log(this.treeDataNode)
              Message({
                type: "success",
                message: "保存成功!",
              });
            } else {
              Message.error(res.message);
            }
          });
        } catch (err) {
          loading.close();
          Message.error("保存失败！");
        }
      },

      async supplierList() {
        try {
          let user = this.$store.getters.getUser;

          let data = {
            tenant_id: user.tenant_id,
          };
          await http.post("/wapi/v1/supplierList", data).then((res) => {
            if (res.success) {
              for (let i = 0; i < res.data.length; i++) {
                let obj = {
                  value: res.data[i].supplier_id,
                  label: res.data[i].supplier_name,
                };
                this.supplierArr.push(obj);
              }
            }
          });
        } catch (err) {
          Message.error("获取失败！");
        }
      },
      async getRoleList() {
        try {
          let user = this.$store.getters.getUser;
          let data = {
            tenant_id: user.tenant_id,
          };

          await http.post("/wapi/v1/getRoleList", data).then((res) => {
            if (res.success) {
              for (let i = 0; i < res.data.length; i++) {
                let obj = {
                  value: res.data[i].role_id,
                  label: res.data[i].role_name,
                };
                this.formlist.options2.push(obj);
                this.form.options2.push(obj);
              }
            }
          });
        } catch (err) {
          Message.error("获取失败！");
        }
      },
      //获取行索引
      tableRowClassName({ row, rowIndex }) {
        // row.index = rowIndex;
      },
      dialogFormVisible2Click() {
        this.dialogFormVisible2 = true;
        this.addForm.bname = this.bname;
        this.addForm.ou_id = this.bname_ou_id;
      },
      rowClick(row, column, even) {
        this.show = true;
        console.log(row);
        if (row) {
          this.formlist.user_id = row.user_id;
          this.formlist.key_id = row.key_id;
          this.radio = parseInt(row.rowIndex);
          this.myStatus = row.status === "ACTIVE" ? "在职" : "离职";

          if (row.zhuGuan === "STAFF") {
            this.myZhuGuan = "否";
            this.form.zhuGuan = false;
          } else if (row.zhuGuan === "MANAGER") {
            this.myZhuGuan = "是";
            this.form.zhuGuan = true;
          }
          this.tabActive = true;
          this.tableDataRow = row;
          console.log(this.tableDataRow, 99);
          this.getExtendedInfo(row.user_id);
        }
      },
      getStatus(status) {
        if (status === "ACTIVE") {
          return "在职";
        } else {
          return "离职";
        }
      },
      reset() {
        this.dialogFormVisible2 = false;
        for (let key in this.addForm) {
          this.addForm[key] = "";
        }
        this.addForm.status = "ACTIVE";
        this.$refs["ruleForm"].resetFields();
      },
      submitForm() {
        this.$refs["ruleForm"].validate((valid) => {
          if (valid) {
            this.addUserOu();
          } else {
            Message.error("保存失败");
            return false;
          }
        });
      },
      handleDetail() { },
      employeesDetails(row) {
        console.log(row);
        this.selectUser = row;

        this.dialogVisible2 = true;
        this.activeName2 = "first";
        this.isfalse = true;
        // console.log(row,55)
        this.baocun = 3;
        this.formlist.department = row.department;
        this.formlist.last_name = row.name;
        this.formlist.onboard_date = row.onboard_date;
        this.formlist.leave_date = row.leave_date;
        this.formlist.employee_code = row.employee_code;
        this.formlist.comments = row.comments;
        this.formlist.status = row.status;
        this.formlist.zhuGuan = row.zhuGuan;
        this.formlist.sex = row.sex;
        this.formlist.birthday = row.birthday;
        this.formlist.phone = row.phone;
        this.formlist.zhuGuan = row.zhuGuan;
        this.formlist.duty = row.duty;
        this.formlist.username = row.username ? row.username : "";
        this.formlist.password = row.password ? row.password : "";
        this.formlist.email = row.email;
        this.formlist.supplier_id = row.supplier_id;
        this.formlist.supplier_user = row.supplier_user;
        this.formlist.outsourcing_user = row.outsourcing_user;
        this.formlist.wecom_id = row.wecom_id;
        this.formlist.om_user_id = row.om_user_id;
        this.formlist.project_array = row.project_array;
        this.formlist.checkin_random = row.checkin_random;
        debugger;
        /* this.form.role=this.tableDataRow.role.data*/
        this.formlist.role = [];
        if (row.role) {
          for (let i = 0; i < row.role.length; i++) {
            let role_id = row.role[i].role_id;
            debugger;
            this.formlist.role.push(role_id);
          }
          console.log(this.formlist.role);
        } else {
          this.formlist.role = [];
        }
        this.getExtendedInfo(row.user_id);
      },
      clickExtension() {
        this.dialogVisible2 = false;
        this.isfalse = false;
        this.extendedInfo1 = JSON.parse(JSON.stringify(this.extendedInfo));
        this.extendedInfo = [];
      },
      addEmployees() {
        if (this.activeName2 == "first") {
          this.$refs["formlist"].validate((valid) => {
            if (!valid) {
              return false;
            } else {
              this.updateUserOu();
            }
          });
        } else {
          let off = true;
          for (var i = 0; i < this.extendedInfo.length; i++) {
            if (this.extendedInfo[i].mandatory == "T") {
              this.$refs["list" + i][0].validate((valid) => {
                console.log(valid);
                if (!valid) {
                  off = false;
                }
              });
            }
          }
          if (off) {
            this.updateExtendedInfo();
          }
        }
      },
      async getExtendedInfo(id) {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          user_id: id,
        };
        await http.post("/wapi/v1/getExtendedInfo", data).then((res) => {
          if (res.success) {
            this.extendedInfo = res.data;
            // console.log(this.extendedInfo,88)

            this.extendedInfo.forEach((item) => {
              if (item.input_type === "LIST" && item.multiple === "T" && item.field_value.indexOf("|") == -1 && item.field_value !== "") {
                item.field_value = [item.field_value];
              }
              if (item.input_type === "LIST" && item.field_value.indexOf("|") !== -1) {
                item.field_value = item.field_value.split("|");
              }

              if (item.input_type === "LIST" && item.multiple === "T" && item.field_value === "") {
                item.field_value = [];
              }
              if (item.input_type === "TRUE-FALSE" && item.field_value === "") {
                item.field_value = "F";
              }
            });
            this.extendedInfo1 = JSON.parse(JSON.stringify(this.extendedInfo));
            // console.log(this.extendedInfo1,99)
          } else {
            Message.error(res.message);
          }
        });
      },
      async updateExtendedInfo() {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          user_id: this.$store.getters.getUser.user_id,
          form_id: this.formlist.user_id,
          ExtensionArray: this.extendedInfo,
        };
        debugger;
        await http.post("/wapi/v1/setExtendedList", data).then((res) => {
          if (res.success) {
            Message({
              type: "success",
              message: "保存成功",
            });

            this.dialogVisible2 = false;
            this.isfalse = false;
            this.getExtendedInfo(this.formlist.user_id);
            this.extendedInfo = [];
          } else {
            Message.error(res.message);
          }
        });
      },
      chooseTimeRange0(t) {
        let time1 = moment(t).valueOf();
        let time2 = moment(this.formlist.leave_date).valueOf();
        if (time1 >= time2) {
          this.$message({
            type: "warning",
            message: "离职日期应晚于入职日期",
          });
          this.formlist.leave_date = "";
        }
      },
      chooseTimeRange2(t) {
        let time1 = moment(t).valueOf();
        let time2 = moment(this.formlist.onboard_date).valueOf();

        if (time1 <= time2) {
          this.$message({
            type: "warning",
            message: "离职日期应晚于入职日期",
          });
          this.formlist.leave_date = "";
        }
      },
    },
    filters: {
      dateFormat: function (val) {
        if (val && val != "null") {
          return moment(val).format("YYYY年M月D日");
        } else {
          return "";
        }
      },
    },
    created() {
      this.getOU();
      this.getRoleList();
      this.supplierList();
      this.getProject();
      //bus.$emit('active',1)
    },

    mounted() {
      //this.$refs.tree.setCheckedKeys("cebdb9db-ebe5-4b3e-8c8c-92a45faa77fd")
    },
    updated() {
      console.log(this.input);
    },
  };
</script>
<style>
  #region {
    background: white;
    border: 1px solid #dcdfe6;
    border-left: none;
    padding: 20px 20px;
    height: 100%;
  }

  #region .cell {
    text-align: left;
  }

  #region .el-radio__label {
    display: none;
  }

  #region .el-table {
    margin-top: 35px;
  }

  #region .redact {
    height: 80px;
    font-size: 12px;
    color: #ff9901;
    border: 1px solid #dcdfe6;
    text-align: center;
  }

  #region .redact .el-col {
    user-select: none;
    padding-top: 14px;
    height: 100%;
    border-left: 1px solid #dcdfe6;
  }

  #region .treeBox {
    border: 1px solid #dcdfe6;
    height: 600px;
    border-top: none;
  }

  #region .el-scrollbar {
    height: 95%;
  }

  #region .el-scrollbar__view {
    height: 100%;
  }

  #region .el-tree .filter-tree .el-tree--highlight-current {
    height: 100%;
  }

  #region .el-tree-node .is-expanded .is-current .is-focusable {
    height: 100%;
  }

  /*!*限制文字长度*!*/
  /*#region .el-tree-node__content span{*/
  /*    max-width: 240px;*/

  /*    overflow: hidden;*/

  /*    text-overflow: ellipsis;*/

  /*    white-space: nowrap;*/
  /*}*/
  /*#region .el-tree-node__expand-icon{*/
  /*    display: none;*/
  /*}*/
  /*#region .el-tree-node__content{*/
  /*    !*display: flex;*!*/
  /*    !*justify-content: space-between;*!*/
  /*    height: 40px;*/
  /*}*/
  /*#region .el-tree-node__content:before{*/
  /*    content: "";*/
  /*    display: inline-block;*/
  /*    !*background: url("../../../assets/images/diction.png") no-repeat;*!*/
  /*    background-size:16px ;*/
  /*    width: 16px;*/
  /*    height: 16px;*/
  /*    margin: 20px;*/
  /*}*/

  #region .el-tree-node__content {
    height: 40px;
  }

  #region .el-tree-node:focus>.el-tree-node__content {
    background-color: #d8f6ee !important;
  }

  #region .icon-t {
    display: inline-block;
    width: 17px;
    height: 18px;
    background: url("../../assets/images/icon-t.png");
  }

  #region .icon-f {
    width: 17px;
    height: 18px;
    background: url("../../assets/images/icon-f.png");
  }

  #region .icon-g {
    width: 17px;
    height: 18px;
    background: url("../../assets/images/icon-g.png");
  }

  #region .el-dialog__close {
    display: none;
  }

  #region .el-form-item__label {
    font-size: 16px;
    color: black;
    text-align: left;
    /*padding-right: 20px;*/
  }

  #inputSeach {
    padding: 0px;
    border: none;
    border-radius: 5px;
    background: rgba(3, 3, 3, 0.1);
    height: 30px;
    text-align: center;
    color: black;
  }

  #el-rowInput .el-input {
    width: 338px;
    padding: 5px 10px;
    border: 1px solid #dedede;
  }

  .upActive {
    opacity: 0.4;
  }

  #region .el-dialog__header {
    border-bottom: 2px dashed #dcdfe6;
    padding: 20px 0 20px 0;
    margin: 20px 20px 10px;
  }

  #wee .el-dialog__header {
    border-bottom: none;
    padding: 10px 0 20px 0;
    margin: 20px 20px 10px;
  }

  #info .el-form-item__label {
    padding-left: 20px;
  }

  #employees .el-form-item__label {
    font-size: 16px;
    color: black;
    text-align: left;
    padding-left: 20px;
    font-weight: bold;
  }

  #employees .el-tag {
    color: #fff;
    background: #ff9901;
    border: none;
  }

  #employees .el-tag.el-tag--info .el-tag__close {
    display: none;
  }

  #employees1 .el-tag {
    color: #fff;
    background: #ff9901;
    border: none;
  }

  #employees1 .el-tag.el-tag--info .el-tag__close {
    display: none;
  }

  #region .el-dialog__body {
    padding-right: 100px;
    padding-top: 20px;
  }

  #region .regionUser .el-dialog__body {
    padding-right: 20px;
    padding-top: 20px;
  }

  #phone .el-dialog__body {
    padding: 20px 80px;
  }

  #region .el-main {
    padding: 0 10px;
  }

  #region .message {}

  #region .el-select-dropdown__item {
    padding: 0 !important;
  }

  .header {
    width: 100%;
    padding-bottom: 20px;
    border-bottom: 2px dotted #e7eaec;
  }

  #el-aside {
    background: white;
  }

  #region .el-table__header .cell {
    /*font-weight: bold;*/
  }

  #el-aside .el-input {
    width: 348px;
    padding: 5px 5px;
    border: 1px solid #dedede;
    border-top: none;
  }

  #el-aside #inputSeach {
    padding: 0px;
    border-radius: 3px;
    background: #ededed;
    height: 30px;
    text-align: center;
  }

  #inputSeach::-webkit-input-placeholder {
    /* WebKit browsers */
  }

  .headerStyle>div {
    font-size: 14px;
    color: #585757;
    font-weight: bold;
  }
</style>
<style scoped>
  #region>>>.region_star label:after {
    content: "*";
    color: #f56c6c;
    margin-left: 4px;
  }

  #region>>>.region_table_cell {
    color: #2b92fa !important;
  }
</style>


// WEBPACK FOOTER //
// src/pages/jurisdiction/region.vue